var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};

module.exports = {
  actions: {
    addToIgnoreList: function(d) { return "Add to ignore list"; },
    cleanup: function(d) { return "Cleanup " + plural(d.count, 0, en, { "0": "", one: "item", other: "items" }); },
    "delete": function(d) { return "Delete permanently"; },
    grantFullAccess: function(d) { return "Grant Full Access"; },
    group: function(d) { return "Group Actions"; },
    moveToBlack: function(d) { return "Move to Black List"; },
    moveToDrop: function(d) { return "Move to Drop List"; },
    moveToQuarantine: function(d) { return "Move to quarantine"; },
    moveToWhite: function(d) { return "Move to White List"; },
    other: function(d) { return "Other Actions"; },
    removeFullAccess: function(d) { return "Remove Full Access"; },
    restoreFromQuarantine: function(d) { return "Restore from quarantine"; },
    scopeToLocal: function(d) { return "Change scope to Local"; },
    scopeToGroup: function(d) { return "Change scope to Group"; },
    restoreOriginal: function(d) { return "Restore original " + plural(d.count, 0, en, { "0": "", one: "item", other: "items" }); },
    tryToRestore: function(d) { return "Try to restore clean version from backup"; },
    viewFile: function(d) { return "View item"; }
  },
  attributions: {
    license: function(d) { return "License"; },
    link: function(d) { return "Link"; },
    name: function(d) { return "Name"; }
  },
  backup: {
    date: {
      everyDay: function(d) { return "Every day"; },
      first: function(d) { return "First"; },
      fourth: function(d) { return "Fourth"; },
      friday: function(d) { return "Friday"; },
      last: function(d) { return "Last"; },
      lastDay: function(d) { return "last day"; },
      monday: function(d) { return "Monday"; },
      mondayToFriday: function(d) { return "Monday to Friday"; },
      ofEachMonth: function(d) { return "of each month"; },
      saturday: function(d) { return "Saturday"; },
      second: function(d) { return "Second"; },
      sunday: function(d) { return "Sunday"; },
      third: function(d) { return "Third"; },
      thursday: function(d) { return "Thursday"; },
      tuesday: function(d) { return "Tuesday"; },
      wednesday: function(d) { return "Wednesday"; },
      onStartup: function(d) { return "On the system startup"; },
      onShutdown: function(d) { return "On the system shutdown"; },
      timeSinceBackupHours: function(d) { return plural(d.count, 0, en, { one: "1 hour", other: number(d.count, "count") + " hours" }) + " since last backup"; },
      timeSinceBackupDays: function(d) { return plural(d.count, 0, en, { one: "1 day", other: number(d.count, "count") + " days" }) + " since last backup"; }
    },
    systems: {
      acronis: function(d) { return "Acronis Backup"; },
      cloudlinux: function(d) { return "CloudLinux Backup"; },
      cloudlinux_on_premise: function(d) { return "CloudLinux Backup On-Premises"; },
      cpanel: function(d) { return "cPanel Backup"; },
      directadmin: function(d) { return "DirectAdmin Backup"; },
      plesk: function(d) { return "Plesk Backup"; },
      clusterlogics: function(d) { return "Clusterlogics Backup"; }
    },
    time: {
      at: function(d) { return ", at " + d.startAt; },
      repeat: function(d) { return " repeat every " + select(d.intervalType, { minutes: plural(d.repeatInterval, 0, en, { one: "1 minute", other: number(d.repeatInterval, "repeatInterval") + " minutes" }), hours: plural(d.repeatInterval, 0, en, { one: "1 hour", other: number(d.repeatInterval, "repeatInterval") + " hours" }), other: "" }) + " from " + d.from + " until " + d.to; }
    }
  },
  blockedPorts: {
    addIpToPortModal: {
      commentPlaceholder: function(d) { return "Enter Description"; },
      confirmText: function(d) { return "Add IP/Subnet"; },
      ipPlaceholder: function(d) { return "Enter IP"; },
      title: function(d) { return "Add IP/Subnet"; }
    },
    addItemTab: {
      commentPlaceholder: function(d) { return "Enter comment"; },
      ipsNote: function(d) { return "Comma-separated list of IPs or subnets in CIDR notation."; },
      ipsPlaceholder: function(d) { return "Whitelisted IPs"; },
      portNote: function(d) { return "Port will be blocked for all IPs, except specified in the field below."; },
      portPlaceholder: function(d) { return "Port"; },
      tcp: function(d) { return "TCP"; },
      udp: function(d) { return "UDP"; }
    },
    notifications: {
      ipAdded: function(d) { return "IP " + d.ip + " has been successfully added to port " + d.port; },
      ipDeleteConfirm: function(d) { return "Delete IP " + d.ip + " from port " + d.port; },
      ipDeleted: function(d) { return "IP " + d.ip + " has been successfully deleted from port " + d.port; },
      ipPortCommentEdited: function(d) { return "Comment for IP " + d.ip + " in port " + d.port + " has been successfully edited"; },
      portAdded: function(d) { return "Port " + d.port + " " + plural(d.count, 0, en, { "0": "", one: "with IP " + d.ip, other: "with IPs " + d.ip }) + " has been added"; },
      portCommentEdited: function(d) { return "Comment for port " + d.port + " has been successfully edited"; },
      portDeleteConfirm: function(d) { return "Delete port " + d.port + " " + plural(d.count, 0, en, { "0": "", one: "with IP:", other: "with IPs:" }); },
      portDeleted: function(d) { return "Port " + d.port + " has been deleted successfully"; }
    },
    table: {
      filterByIp: function(d) { return "Filter by IP"; },
      headers: {
        ips: function(d) { return "Whitelisted IPs"; },
        note: function(d) { return "Note"; },
        port: function(d) { return "Port"; }
      },
      ipsTooltip: function(d) { return "The list of IPs for which port is unblocked"; },
      loadMore: function(d) { return "Load more"; }
    },
    defaultBlocking: {
      title: function(d) { return "Default Blocking Mode"; },
      options: {
        open: function(d) { return "All open, except specified"; },
        close: function(d) { return "All close, except specified"; }
      }
    },
    tcpInbound: {
      title: function(d) { return "TCP inbound Ports"; },
      description: function(d) { return "Comma-separated list of ports to open for inbound TCP traffic (IPv4)"; }
    },
    tcpOutbound: {
      title: function(d) { return "TCP outbound Ports"; },
      description: function(d) { return "Comma-separated list of ports to open for outbound TCP traffic (IPv4)"; }
    },
    udpInbound: {
      title: function(d) { return "UDP inbound Ports"; },
      description: function(d) { return "Comma-separated list of ports to open for inbound UDP traffic (IPv4)"; }
    },
    udpOutbound: {
      title: function(d) { return "UDP outbound Ports"; },
      description: function(d) { return "Comma-separated list of ports to open for outbound UDP traffic (IPv4)"; }
    },
    confirmModal: {
      description: function(d) { return "You’re switching to the blocking mode, so the access to all ports except the listed below will be blocked. Make sure that SSH/Hosting Panel ports have been added to the list of open ports."; },
      aboutItems: function(d) { return "The following ports will be open:"; },
      titles: function(d) { return "Attention!"; },
      confirms: function(d) { return "APPLY"; },
      tableTitles: {
        portsType: function(d) { return "Ports type"; },
        ports: function(d) { return "Open Ports"; },
        tcpInbound: function(d) { return "TCP inbound"; },
        tcpOutbound: function(d) { return "TCP outbound"; },
        udpInbound: function(d) { return "UDP inbound"; },
        udpOutbound: function(d) { return "UDP outbound"; }
      }
    },
    submit: function(d) { return "APPLY"; }
  },
  comingSoon: {
    teaser: function(d) { return "This cool feature is coming soon"; }
  },
  country: {
    AD: function(d) { return "Andorra"; },
    AE: function(d) { return "United Arab Emirates"; },
    AF: function(d) { return "Afghanistan"; },
    AG: function(d) { return "Antigua and Barbuda"; },
    AI: function(d) { return "Anguilla"; },
    AL: function(d) { return "Albania"; },
    AM: function(d) { return "Armenia"; },
    AO: function(d) { return "Angola"; },
    AQ: function(d) { return "Antarctica"; },
    AR: function(d) { return "Argentina"; },
    AS: function(d) { return "American Samoa"; },
    AT: function(d) { return "Austria"; },
    AU: function(d) { return "Australia"; },
    AW: function(d) { return "Aruba"; },
    AX: function(d) { return "Åland"; },
    AZ: function(d) { return "Azerbaijan"; },
    BA: function(d) { return "Bosnia and Herzegovina"; },
    BB: function(d) { return "Barbados"; },
    BD: function(d) { return "Bangladesh"; },
    BE: function(d) { return "Belgium"; },
    BF: function(d) { return "Burkina Faso"; },
    BG: function(d) { return "Bulgaria"; },
    BH: function(d) { return "Bahrain"; },
    BI: function(d) { return "Burundi"; },
    BJ: function(d) { return "Benin"; },
    BL: function(d) { return "Saint-Barthélemy"; },
    BM: function(d) { return "Bermuda"; },
    BN: function(d) { return "Brunei"; },
    BO: function(d) { return "Bolivia"; },
    BQ: function(d) { return "Bonaire, Sint Eustatius, and Saba"; },
    BR: function(d) { return "Brazil"; },
    BS: function(d) { return "Bahamas"; },
    BT: function(d) { return "Bhutan"; },
    BW: function(d) { return "Botswana"; },
    BY: function(d) { return "Belarus"; },
    BZ: function(d) { return "Belize"; },
    CA: function(d) { return "Canada"; },
    CC: function(d) { return "Cocos [Keeling] Islands"; },
    CD: function(d) { return "Congo"; },
    CF: function(d) { return "Central African Republic"; },
    CG: function(d) { return "Republic of the Congo"; },
    CH: function(d) { return "Switzerland"; },
    CI: function(d) { return "Ivory Coast"; },
    CK: function(d) { return "Cook Islands"; },
    CL: function(d) { return "Chile"; },
    CM: function(d) { return "Cameroon"; },
    CN: function(d) { return "China"; },
    CO: function(d) { return "Colombia"; },
    CR: function(d) { return "Costa Rica"; },
    CU: function(d) { return "Cuba"; },
    CV: function(d) { return "Cape Verde"; },
    CW: function(d) { return "Curaçao"; },
    CX: function(d) { return "Christmas Island"; },
    CY: function(d) { return "Cyprus"; },
    CZ: function(d) { return "Czechia"; },
    DE: function(d) { return "Germany"; },
    DJ: function(d) { return "Djibouti"; },
    DK: function(d) { return "Denmark"; },
    DM: function(d) { return "Dominica"; },
    DO: function(d) { return "Dominican Republic"; },
    DZ: function(d) { return "Algeria"; },
    EC: function(d) { return "Ecuador"; },
    EE: function(d) { return "Estonia"; },
    EG: function(d) { return "Egypt"; },
    ER: function(d) { return "Eritrea"; },
    ES: function(d) { return "Spain"; },
    ET: function(d) { return "Ethiopia"; },
    FI: function(d) { return "Finland"; },
    FJ: function(d) { return "Fiji"; },
    FK: function(d) { return "Falkland Islands"; },
    FM: function(d) { return "Federated States of Micronesia"; },
    FO: function(d) { return "Faroe Islands"; },
    FR: function(d) { return "France"; },
    GA: function(d) { return "Gabon"; },
    GB: function(d) { return "United Kingdom"; },
    GD: function(d) { return "Grenada"; },
    GE: function(d) { return "Georgia"; },
    GF: function(d) { return "French Guiana"; },
    GG: function(d) { return "Guernsey"; },
    GH: function(d) { return "Ghana"; },
    GI: function(d) { return "Gibraltar"; },
    GL: function(d) { return "Greenland"; },
    GM: function(d) { return "Gambia"; },
    GN: function(d) { return "Guinea"; },
    GP: function(d) { return "Guadeloupe"; },
    GQ: function(d) { return "Equatorial Guinea"; },
    GR: function(d) { return "Greece"; },
    GS: function(d) { return "South Georgia and the South Sandwich Islands"; },
    GT: function(d) { return "Guatemala"; },
    GU: function(d) { return "Guam"; },
    GW: function(d) { return "Guinea-Bissau"; },
    GY: function(d) { return "Guyana"; },
    HK: function(d) { return "Hong Kong"; },
    HN: function(d) { return "Honduras"; },
    HR: function(d) { return "Croatia"; },
    HT: function(d) { return "Haiti"; },
    HU: function(d) { return "Hungary"; },
    ID: function(d) { return "Indonesia"; },
    IE: function(d) { return "Ireland"; },
    IL: function(d) { return "Israel"; },
    IM: function(d) { return "Isle of Man"; },
    IN: function(d) { return "India"; },
    IO: function(d) { return "British Indian Ocean Territory"; },
    IQ: function(d) { return "Iraq"; },
    IR: function(d) { return "Iran"; },
    IS: function(d) { return "Iceland"; },
    IT: function(d) { return "Italy"; },
    JE: function(d) { return "Jersey"; },
    JM: function(d) { return "Jamaica"; },
    JO: function(d) { return "Hashemite Kingdom of Jordan"; },
    JP: function(d) { return "Japan"; },
    KE: function(d) { return "Kenya"; },
    KG: function(d) { return "Kyrgyzstan"; },
    KH: function(d) { return "Cambodia"; },
    KI: function(d) { return "Kiribati"; },
    KM: function(d) { return "Comoros"; },
    KN: function(d) { return "Saint Kitts and Nevis"; },
    KP: function(d) { return "North Korea"; },
    KR: function(d) { return "Republic of Korea"; },
    KW: function(d) { return "Kuwait"; },
    KY: function(d) { return "Cayman Islands"; },
    KZ: function(d) { return "Kazakhstan"; },
    LA: function(d) { return "Laos"; },
    LB: function(d) { return "Lebanon"; },
    LC: function(d) { return "Saint Lucia"; },
    LI: function(d) { return "Liechtenstein"; },
    LK: function(d) { return "Sri Lanka"; },
    LR: function(d) { return "Liberia"; },
    LS: function(d) { return "Lesotho"; },
    LT: function(d) { return "Republic of Lithuania"; },
    LU: function(d) { return "Luxembourg"; },
    LV: function(d) { return "Latvia"; },
    LY: function(d) { return "Libya"; },
    MA: function(d) { return "Morocco"; },
    MC: function(d) { return "Monaco"; },
    MD: function(d) { return "Republic of Moldova"; },
    ME: function(d) { return "Montenegro"; },
    MF: function(d) { return "Saint Martin"; },
    MG: function(d) { return "Madagascar"; },
    MH: function(d) { return "Marshall Islands"; },
    MK: function(d) { return "North Macedonia"; },
    ML: function(d) { return "Mali"; },
    MM: function(d) { return "Myanmar [Burma]"; },
    MN: function(d) { return "Mongolia"; },
    MO: function(d) { return "Macao"; },
    MP: function(d) { return "Northern Mariana Islands"; },
    MQ: function(d) { return "Martinique"; },
    MR: function(d) { return "Mauritania"; },
    MS: function(d) { return "Montserrat"; },
    MT: function(d) { return "Malta"; },
    MU: function(d) { return "Mauritius"; },
    MV: function(d) { return "Maldives"; },
    MW: function(d) { return "Malawi"; },
    MX: function(d) { return "Mexico"; },
    MY: function(d) { return "Malaysia"; },
    MZ: function(d) { return "Mozambique"; },
    NA: function(d) { return "Namibia"; },
    NC: function(d) { return "New Caledonia"; },
    NE: function(d) { return "Niger"; },
    NF: function(d) { return "Norfolk Island"; },
    NG: function(d) { return "Nigeria"; },
    NI: function(d) { return "Nicaragua"; },
    NL: function(d) { return "Netherlands"; },
    NO: function(d) { return "Norway"; },
    NP: function(d) { return "Nepal"; },
    NR: function(d) { return "Nauru"; },
    NU: function(d) { return "Niue"; },
    NZ: function(d) { return "New Zealand"; },
    OM: function(d) { return "Oman"; },
    PA: function(d) { return "Panama"; },
    PE: function(d) { return "Peru"; },
    PF: function(d) { return "French Polynesia"; },
    PG: function(d) { return "Papua New Guinea"; },
    PH: function(d) { return "Philippines"; },
    PK: function(d) { return "Pakistan"; },
    PL: function(d) { return "Poland"; },
    PM: function(d) { return "Saint Pierre and Miquelon"; },
    PN: function(d) { return "Pitcairn Islands"; },
    PR: function(d) { return "Puerto Rico"; },
    PS: function(d) { return "Palestine"; },
    PT: function(d) { return "Portugal"; },
    PW: function(d) { return "Palau"; },
    PY: function(d) { return "Paraguay"; },
    QA: function(d) { return "Qatar"; },
    RE: function(d) { return "Réunion"; },
    RO: function(d) { return "Romania"; },
    RS: function(d) { return "Serbia"; },
    RU: function(d) { return "Russia"; },
    RW: function(d) { return "Rwanda"; },
    SA: function(d) { return "Saudi Arabia"; },
    SB: function(d) { return "Solomon Islands"; },
    SC: function(d) { return "Seychelles"; },
    SD: function(d) { return "Sudan"; },
    SE: function(d) { return "Sweden"; },
    SG: function(d) { return "Singapore"; },
    SH: function(d) { return "Saint Helena"; },
    SI: function(d) { return "Slovenia"; },
    SJ: function(d) { return "Svalbard and Jan Mayen"; },
    SK: function(d) { return "Slovak Republic"; },
    SL: function(d) { return "Sierra Leone"; },
    SM: function(d) { return "San Marino"; },
    SN: function(d) { return "Senegal"; },
    SO: function(d) { return "Somalia"; },
    SR: function(d) { return "Suriname"; },
    SS: function(d) { return "South Sudan"; },
    ST: function(d) { return "São Tomé and Príncipe"; },
    SV: function(d) { return "El Salvador"; },
    SX: function(d) { return "Sint Maarten"; },
    SY: function(d) { return "Syria"; },
    SZ: function(d) { return "Swaziland"; },
    TC: function(d) { return "Turks and Caicos Islands"; },
    TD: function(d) { return "Chad"; },
    TF: function(d) { return "French Southern Territories"; },
    TG: function(d) { return "Togo"; },
    TH: function(d) { return "Thailand"; },
    TJ: function(d) { return "Tajikistan"; },
    TK: function(d) { return "Tokelau"; },
    TL: function(d) { return "East Timor"; },
    TM: function(d) { return "Turkmenistan"; },
    TN: function(d) { return "Tunisia"; },
    TO: function(d) { return "Tonga"; },
    TR: function(d) { return "Turkey"; },
    TT: function(d) { return "Trinidad and Tobago"; },
    TV: function(d) { return "Tuvalu"; },
    TW: function(d) { return "Taiwan"; },
    TZ: function(d) { return "Tanzania"; },
    UA: function(d) { return "Ukraine"; },
    UG: function(d) { return "Uganda"; },
    UM: function(d) { return "U.S. Minor Outlying Islands"; },
    US: function(d) { return "United States"; },
    UY: function(d) { return "Uruguay"; },
    UZ: function(d) { return "Uzbekistan"; },
    VA: function(d) { return "Vatican City"; },
    VC: function(d) { return "Saint Vincent and the Grenadines"; },
    VE: function(d) { return "Venezuela"; },
    VG: function(d) { return "British Virgin Islands"; },
    VI: function(d) { return "U.S. Virgin Islands"; },
    VN: function(d) { return "Vietnam"; },
    VU: function(d) { return "Vanuatu"; },
    WF: function(d) { return "Wallis and Futuna"; },
    WS: function(d) { return "Samoa"; },
    XK: function(d) { return "Kosovo"; },
    YE: function(d) { return "Yemen"; },
    YT: function(d) { return "Mayotte"; },
    ZA: function(d) { return "South Africa"; },
    ZM: function(d) { return "Zambia"; },
    ZW: function(d) { return "Zimbabwe"; }
  },
  dashboard: {
    recommendations: {
      status: {
        title: function(d) { return "Protection status"; },
        issuesCount: function(d) { return plural(d.count, 0, en, { one: "issue", other: "issues" }); },
        poor: {
          title: function(d) { return "Poor"; },
          subtitle: function(d) { return "Server is unprotected"; }
        },
        medium: {
          title: function(d) { return "Medium"; },
          subtitle: function(d) { return "Server has some issues"; }
        },
        good: {
          title: function(d) { return "Good"; },
          subtitle: function(d) { return "Server is fully protected"; }
        },
        unknown: {
          title: function(d) { return "Unknown"; },
          subtitle: function(d) { return "Unknown"; }
        }
      },
      lists: {
        title: function(d) { return "What to do?"; },
        updateInterval: function(d) { return "Updating daily"; },
        no: function(d) { return "No recommendations for now"; },
        titles: {
          poor: function(d) { return "Important"; },
          medium: function(d) { return "Medium"; },
          good: function(d) { return "Optional"; }
        }
      }
    },
    charts: {
      events: function(d) { return "Events: " + d.numberOfEvents; },
      incidents: function(d) { return "Incidents"; },
      timeFrom: function(d) { return "From: " + d.from; },
      timeTo: function(d) { return "To: " + d.to; },
      total: function(d) { return "Total"; }
    },
    haveNewIncidents: function(d) { return "You have new incidents"; },
    incidents: {
      abuserIp: function(d) { return "Abuser IP"; },
      addIpToBlack: function(d) { return "Add ip to black list"; },
      byAbuserIpTooltip: function(d) { return "click to search by IP"; },
      descriptionIp: function(d) { return "Description/IP"; },
      descriptionWidget: function(d) { return "Description"; },
      details: {
        abuser: function(d) { return "Abuser"; },
        domain: function(d) { return "Domain"; },
        rule: function(d) { return "Rule"; },
        sensor: function(d) { return "Sensor"; }
      },
      differentSensorsTooltip: function(d) { return "Incidents from different sensors have different severity scales."; },
      disableAction: function(d) { return "Disable rule"; },
      domainWidget: function(d) { return "Domain"; },
      eventTypeWidget: function(d) { return "Event type"; },
      headers: {
        country: function(d) { return "Country"; },
        date: function(d) { return "Date"; },
        event: function(d) { return "Event"; },
        ip: function(d) { return "IP"; },
        numberOfTimes: function(d) { return "Count"; },
        severity: function(d) { return "Severity"; }
      },
      mappedTooltip: function(d) { return "OSSEC's scale mapped to modsec's."; },
      modal: {
        commaSeparatedWarning: function(d) { return "To disable this rule only for some domains, enter comma separate list of domains here."; },
        confirmText: function(d) { return "Yes, disable"; },
        otherwiseWarning: function(d) { return "Otherwise, rule will be disabled for all domains"; },
        title: function(d) { return "Disable " + d.plugin + " rule"; },
        warning: function(d) { return "By disabling this rule, you might leave parts of your site unprotected"; }
      },
      moveToBlackAction: function(d) { return "Move to Black List"; },
      moveToBlackWithGroupScopeAction: function(d) { return "Move to Black List with group scope"; },
      moveToWhiteAction: function(d) { return "Move to White List"; },
      moveToWhiteWithGroupScopeAction: function(d) { return "Move to White List with group scope"; },
      noSeverityTooltip: function(d) { return "Incidents without severity will be in the end of the list."; },
      numberOfTimes: function(d) { return plural(d.count, 0, en, { one: "(1 time)", other: "(" + number(d.count, "count") + " times)" }); },
      removeAction: function(d) { return "Remove from IP lists"; },
      title: function(d) { return "Incidents"; }
    },
    statusWarning: {
      text: function(d) { return "You have " + d.count + " " + plural(d.count, 0, en, { one: "server", other: "servers" }) + " with a Poor protection status"; },
      tooltip: function(d) { return "Check servers in server drop-down list"; }
    },
    incidentsAndAlerts: {
      bottomWarning: {
        text: function(d) { return "Charts may have gaps. This means that no incidents or alerts were recorded during that day. Some charts may be hidden if no alerts of a particular type were recorded within the selected interval.  See the |Dashboard section| for details and troubleshooting tips."; },
        title: function(d) { return "Note!"; }
      },
      bruteforce_attacks: {
        description: function(d) { return "Web-based brute-force attacks against the CMS and hosting panel, and incidents recorded by ModSecurity."; },
        numTitle: function(d) { return "Bruteforce attacks"; },
        title: function(d) { return "Web-based Brute-force Attacks"; }
      },
      captcha_blocked: {
        description: function(d) { return "Recorded requests coming from detected attackers or bad bots that show the SplashScreen challenge within the selected interval. See the documentation for details on |SplashScreen."; },
        numTitle: function(d) { return "SplashScreen events"; },
        title: function(d) { return "SplashScreen events"; }
      },
      denied_bot_attacks: {
        description: function(d) { return "Attacks detected by the Imunify360 Bot-Detector heuristics-based plugin. Bot-Detector is a part of Imunify360’s “herd immunity” feature that collects and analyzes a massive amount of information on new attacks on a global scale which it uses to prevent attacks across multiple servers."; },
        numTitle: function(d) { return "Denied bad bot requests"; },
        title: function(d) { return "Denied Requests from Bad Bots"; }
      },
      num_of_mrs: {
        description: function(d) { return "A number of unique malicious files detected within the selected period. |See the User| tab for details."; },
        numTitle: function(d) { return "Detected malware"; },
        title: function(d) { return "Detected malware"; }
      },
      num_of_cleanups: {
        description: function(d) { return "A number of unique malicious files cleaned within the selected period. |See the History| tab for details."; },
        numTitle: function(d) { return "Cleaned malicious files"; },
        title: function(d) { return "Cleaned malicious files"; }
      },
      description: function(d) { return "These charts give an overview of incidents recorded during the selected time interval, an estimate of the intensity of attacks, and correlate events across all sources."; },
      empty: function(d) { return "No alerts and critical events were recorded within the selected interval. To remedy, select a longer interval or reload the Dashboard later."; },
      failedToFetch: function(d) { return "Failed to fetch data. Specify more narrow period or try again later."; },
      noGeoIp: function(d) { return "None of the incidents have GeoIP data."; },
      heatmap: function(d) { return "Heatmap"; },
      help: function(d) { return "See the |Dashboard section| for details and troubleshooting tips."; },
      histogram: function(d) { return "Histogram"; },
      num_of_alerts: {
        description: function(d) { return "Security incidents recorded within the selected time interval. Data includes all ModSecurity incidents, Imunify360 DOS plugin alerts, OSSEC alerts and some others. This is a summary of all major alert sources."; },
        numTitle: function(d) { return "Alert total"; },
        title: function(d) { return "Alerts total"; }
      },
      ossec_alerts: {
        description: function(d) { return "Attacks against network services, e.g. FTP, SSH, POP, IMAP, etc., recorded by OSSEC IDS  within the selected time interval. It includes authentication failures, requests from blocked IPs, break-in attempts alerts and more."; },
        numTitle: function(d) { return "OSSEC alerts"; },
        title: function(d) { return "OSSEC: Network Level Attacks"; }
      },
      spam_ham: {
        description: function(d) { return "These charts give an overview of incidents recorded during the selected time interval, an estimate of the intensity of attacks, and correlate events across all sources."; },
        numTitle: function(d) { return "Spam Emails"; },
        title: function(d) { return "Good vs Bad Emails"; },
        ham: function(d) { return "Good Emails (HAM)"; },
        spam: function(d) { return "Spam"; }
      },
      title: function(d) { return "Incidents and Alerts"; },
      waf_alerts: {
        description: function(d) { return "Web attacks recorded by ModSecurity within the selected time interval. It may include CMS brute-force and login attempts, websites hacking attempts, attempts to access “sensitive” files or restricted areas, and other malicious requests."; },
        numTitle: function(d) { return "WAF alerts"; },
        title: function(d) { return "WAF alerts"; }
      }
    },
    menu: {
      chart: function(d) { return "Chart"; },
      heatmap: function(d) { return "Heatmap"; }
    },
    serverIdWidget: {
      keyButtonText: function(d) { return "Copy key"; },
      serverStatus: function(d) { return "Status: " + select(d.severity, { poor: "Poor", medium: "Medium", good: "Good", other: "Unknown" }); },
      trashButtonText: function(d) { return "Remove server"; },
      addModal: {
        authenticationError: function(d) { return "Registration process is not finished yet, please try again in few seconds."; },
        confirmNote: function(d) { return "This action is not allowed in demo version"; },
        description: function(d) { return "Please enter a server key to add it to the Imunify360 dashboard"; },
        description2: function(d) { return "You can copy a server key to the clipboard by clicking on the key symbol|button."; },
        description3: function(d) { return "Alternatively, find your server key in the id field of the|file."; },
        description4: function(d) { return "Read more here."; },
        nearInputTooltip: function(d) { return "A server key uniquely identifies an installed Imunify360 instance."; },
        note: function(d) { return "To add several keys, separate them with a comma."; },
        placeholder: function(d) { return "Server key"; },
        title: function(d) { return "Add server key"; }
      },
      addServerButtonText: function(d) { return "Add server"; },
      deleteModal: {
        body: function(d) { return "The following server will be removed from the dashboard:"; },
        title: function(d) { return "Removing server from dashboard"; }
      },
      keyButtonTooltip: function(d) { return "Copy server key to clipboard"; },
      placeholder: function(d) { return "Server"; },
      trashButtonTooltip: function(d) { return "Remove the server from the dashboard"; }
    },
    advisorModal: {
      title: function(d) { return "Imunify Advisor"; },
      subTitle: function(d) { return "Recommended changes in the settings for your server:"; },
      description: function(d) { return "Notes:"; },
      description1: function(d) { return "* Uncheck the item so that it will not be applied"; },
      description2: function(d) { return "* You can always change the settings back in Settings tab."; },
      confirmText: function(d) { return "Apply"; }
    },
    title: function(d) { return "Dashboard"; }
  },
  eula: {
    accept: function(d) { return "accept"; },
    acceptOrUninstall: function(d) { return "You cannot use " + d.productName + " without accepting updated EULA, please, either accept EULA or uninstall " + d.productName; },
    acceptUpdated: function(d) { return "We've updated the EULA, you need to accept it to continue using " + d.productName; },
    back: function(d) { return "Back"; },
    decline: function(d) { return "decline"; },
    sorry: function(d) { return "Sorry :("; }
  },
  featuresDisabled: {
    contactProvider: function(d) { return "Please contact your hosting provider to enable them."; },
    noFeatures: function(d) { return "No features are available."; }
  },
  forLinguists: {
    description: function(d) { return "In this block you can find links to the syntax documentation as well as some examples of that syntax"; },
    helpCut: function(d) { return "Strings with symbol | will be divided: https://github.com/ngx-translate/core/issues/223#issuecomment-333335132"; },
    helpUrl: function(d) { return "http://messageformat.github.io/messageformat/"; },
    plural: function(d) { return "There " + plural(d.count, 0, en, { "0": "is nothing", one: "is one thing", other: "are " + number(d.count, "count") + " things" }); },
    pluralUrl: function(d) { return "https://unicode-org.github.io/cldr-staging/charts/latest/supplemental/language_plural_rules.html"; },
    selectAndVariable: function(d) { return select(d.gender, { male: "He is", female: "She is", other: "They are" }) + " " + d.how; },
    translation: function(d) { return "English"; }
  },
  interceptors: {
    sessionExpired: {
      connectionReset: function(d) { return "Your connection was reset or session has expired. Please reload the page"; },
      internalError: function(d) { return "Internal Error"; },
      sessionExpired: function(d) { return "Your session has expired. Please reload the page"; }
    }
  },
  kernelcare: {
    autoUpdate: function(d) { return "Auto update:"; },
    detecting: function(d) { return "Detecting..."; },
    effectiveKernelVersion: function(d) { return "Effective Kernel Version"; },
    fetchPatchButton: function(d) { return "See patch info"; },
    fetching: function(d) { return "Fetching..."; },
    installing: function(d) { return "Installing..."; },
    latest: function(d) { return "Latest, no patches needed"; },
    notInstalled: function(d) { return "KernelCare is not installed. You can install it from <strong>Settings</strong> tab"; },
    patchInfo: function(d) { return "Patch Info"; },
    realKernelVersion: function(d) { return "Real Kernel Version"; },
    removing: function(d) { return "Removing..."; },
    unsupported: function(d) { return "KernelCare is unsupported."; },
    unsupportedKernel: function(d) { return "Unsupported kernel, please, contact|for more info"; },
    update: {
      no: function(d) { return "No"; },
      yes: function(d) { return "Yes"; }
    },
    updateButton: function(d) { return "Update now"; },
    updateMode: function(d) { return "Update mode"; },
    updatesAvailable: function(d) { return "Updates available"; },
    uptime: function(d) { return "Uptime"; }
  },
  license: {
    checkButton: function(d) { return "Check"; },
    disabled: function(d) { return "Your " + d.productName + " license is disabled."; },
    exceeded: function(d) { return "Your " + d.productName + " limits have been exceeded."; },
    exceededText: function(d) { return "Your server license supports only " + d.limit + " users. Currently, you have " + d.count + " users."; },
    howToUpdate: function(d) { return "To update your activation key use the form below or login to your server via SSH and run command:"; },
    upgradeLicense: function(d) { return "Upgrade License"; },
    login: function(d) { return "Login to|and check your licenses and activation keys."; },
    notInstalled: function(d) { return "The license is not installed"; },
    placeholder: function(d) { return "Enter activation key"; },
    sales: function(d) { return "With any purchasing questions, please reach out to"; },
    supportHelp: function(d) { return "If you need help with your license, please email support at"; },
    toBuy: function(d) { return "To buy a license, click on this link:"; },
    toBuyInMarket: function(d) { return "Buy a license"; }
  },
  lists: {
    addForm: {
      fullAccess: function(d) { return "Full Access"; },
      ipNote: function(d) { return "IP or subnet in CIDR notation"; },
      ipTooltip: function(d) { return "Example: 1.2.3.4, 1.2.3.0/24, 1111:2222:3333:4444::/64, 1111:2222:3333::/48"; },
      placeholders: {
        comment: function(d) { return "Enter comment"; },
        country: function(d) { return "Enter country"; },
        countryWarning: function(d) { return "Not applicable to synced IPs"; },
        ip: function(d) { return "Enter IP"; }
      },
      radioList: function(d) { return select(d.type, { white: "White", black: "Black", drop: "Black", other: "" }) + " list"; },
      radioScope: function(d) { return select(d.type, { local: "Local", group: "Group", other: "" }); }
    },
    firewall: {
      menu: {
        all: function(d) { return "All Lists"; },
        blockedPorts: function(d) { return "Ports"; }
      },
      placeholders: {
        comments: function(d) { return "Comments"; }
      },
      searchResults: function(d) { return "Search results:"; },
      title: function(d) { return "Firewall"; }
    },
    lists: {
      purpose: {
        drop: function(d) { return "Drop"; },
        white: function(d) { return "White"; },
        captcha: function(d) { return "GreyList"; },
        splashscreen: function(d) { return "SplashScreen"; }
      },
      search: {
        blockTitle: function(d) { return "Search results"; },
        white: function(d) { return "White"; },
        drop: function(d) { return "Drop"; },
        black: function(d) { return "Black"; },
        captcha: function(d) { return "GreyList"; },
        splashscreen: function(d) { return "SplashScreen"; },
        server: function(d) { return "Server"; },
        cloud: function(d) { return "Cloud"; }
      },
      searchHints: {
        white: function(d) { return "The IP will not be blocked"; },
        drop: function(d) { return "The IP will be blocked everywhere, on all ports and services"; },
        captcha: function(d) { return "The IP will be blocked completely on non-web ports (SSH, FTP, etc.), and will be shown SplashScreen on web ports (80, 443, hosting panel ports)"; },
        splashscreen: function(d) { return "The IP will be shown SplashScreen challenge on web ports, and will not be blocked on others"; }
      },
      csfWarning: function(d) { return "Warning: CSF is enabled. Please manage IPs in CSF using|CSF user interface|or config file."; },
      webshieldWarning: {
        title: function(d) { return "SplashScreen is disabled while the WebShield is off."; },
        note: function(d) { return "You can turn on the WebShield via |Settings->General->WebShield->Enable|"; }
      },
      scope: {
        local: function(d) { return "Local"; },
        group: function(d) { return "Group"; }
      },
      headers: {
        comment: function(d) { return "Comment"; },
        list: function(d) { return "List"; },
        purpose: function(d) { return "Purpose"; },
        country: function(d) { return "Country"; },
        ip: function(d) { return "IP"; },
        source: function(d) { return "Source"; },
        scope: function(d) { return "Scope"; },
        ttl: function(d) { return "TTL"; }
      },
      notifications: {
        fullAccess: function(d) { return "Full Access for " + plural(d.count, 0, en, { one: "IP", other: "IPs" }) + " " + d.ips + " has been " + select(d.action, { removed: "removed", granted: "granted", other: "" }) + " successfully"; },
        scope: function(d) { return "Scope for " + d.ips + " has been changed to " + d.type + " successfully"; }
      },
      onlyManual: function(d) { return "Show only manually added"; },
      tooltips: {
        fullAccess: function(d) { return "This IP has FULL access to all ports"; },
        usersIp: function(d) { return "User's IP"; }
      }
    }
  },
  login: {
    error: {
      credentials: function(d) { return "Username or password is incorrect"; },
      service: function(d) { return "Can't connect to agent. Check php part of application."; }
    },
    passwordPlaceholder: function(d) { return "Password"; },
    submit: function(d) { return "Login"; },
    usernamePlaceholder: function(d) { return "Username"; }
  },
  malware: {
    resourceType: function(d) { return "Type"; },
    appRoot: function(d) { return "App root"; },
    dbName: function(d) { return "Database name"; },
    appLocation: function(d) { return "Location"; },
    confirmModal: {
      addToIgnore: function(d) { return "Add to ignore list"; },
      changeIn: function(d) { return "You can change this behavior in"; },
      link: function(d) { return "settings."; },
      send: function(d) { return plural(d.count, 0, en, { one: "The file", other: "Files" }) + " will be sent to the " + d.productName + " team for analysis."; }
    },
    ignoreList: {
      add: function(d) { return "Add new entry"; },
      addPathModal: {
        confirmText: function(d) { return "Add"; },
        pathPlaceholder: {
          file: function(d) { return "File or directory"; },
          db: function(d) { return "Application path"; }
        },
        typePlaceholder: function(d) { return "Type"; },
        type: {
          file: function(d) { return "File"; },
          db: function(d) { return "DB"; }
        },
        title: function(d) { return "Add new entry"; }
      },
      description: function(d) { return "The list of the files to be skipped by malware scanner"; },
      headers: {
        addedDate: function(d) { return "Date"; },
        path: function(d) { return "Path"; }
      },
      removeAction: function(d) { return "Remove from ignore list"; },
      removeModal: {
        confirmText: function(d) { return "Yes, delete from ignore"; },
        subtitle: function(d) { return "File(s) will be scanned again after removing from Ignore list"; },
        title: function(d) { return "Delete from Ignore List"; }
      },
      title: function(d) { return "Ignore list"; }
    },
    cleanupRequiresMyImunifyAccountProtection: function(d) { return "Cleanup requires MyImunify Account Protection"; },
    statusTooltips: {
      cleanup_requires_myimunify_protection: {
        admin: function(d) { return "This file was not cleaned up automatically because it requires for the user to have the MyImunify account protection. This pack is focused on front-end only malware, that doesn't threaten the server security"; },
        client: function(d) { return "This malware file cannot be cleaned without MyImunify account protection. Please contact your hoster for an advanced cleanup."; }
      },
      requires_myimunify_protection: {
        admin: function(d) { return "This file was not cleaned up automatically because it requires for the user to have the MyImunify account protection. This pack is focused on front-end only malware, that doesn't threaten the server security"; },
        client: function(d) { return "This malware file cannot be cleaned without MyImunify account protection. Please contact your hoster for an advanced cleanup."; }
      }
    },
    inlineScanStatus: {
      clean: function(d) { return "Malware cleaned, |see History tab|"; },
      "cleanup-running": function(d) { return "Cleaning up..."; },
      infected: function(d) { return plural(d.file, 0, en, { "0": "", other: number(d.file, "file") + " file" + plural(d.db, 0, en, { "0": "", other: "," }) + " " }) + " " + plural(d.db, 0, en, { "0": "", other: number(d.db, "db") + " DB" }) + " " + plural(d.threat, 0, en, { "0": "", one: "threat", other: "threats" }); },
      "new": function(d) { return "Not yet scanned"; },
      notFound: function(d) { return "No malware found"; },
      "scan-queued-background": function(d) { return "Scanning scheduled"; },
      "scan-queued-on-demand": function(d) { return "Scanning queued"; },
      "scan-queued-user": function(d) { return "User scanning queued"; },
      "scan-running-background": function(d) { return "Background scanning..."; },
      "scan-running-on-demand": function(d) { return "On-Demand scanning..."; },
      "scan-running-user": function(d) { return "User scanning..."; }
    },
    malicious: {
      alsoRestore: function(d) { return plural(d.count, 0, en, { "0": "", one: "(also restore 1 file)", other: "(also restore " + number(d.count, "count") + " files)" }); },
      cleanupAll: function(d) { return "Clean up all"; },
      cleanupAllEndUserWarning: {
        title: function(d) { return "License required"; },
        description: function(d) { return "Contact server administrator to get your ImunifyAV+ or Imunify360 version!"; }
      },
      cleanupBackupWarning: function(d) { return "Original (infected) files backup will be available for " + plural(d.days, 0, en, { one: "1 day", other: number(d.days, "days") + " days" }) + " after cleanup was performed. You'll see \"Cleaned\" and \"Removed\" items in the Malicious Files table until that backup is removed."; },
      cleanupBackupWarning_2: function(d) { return "Original backup will be available for " + plural(d.days, 0, en, { one: "1 day", other: number(d.days, "days") + " days" }) + " after cleanup was performed. You'll see \"Cleaned\" and \"Removed\" items in the Malicious Files table until that backup is removed."; },
      extraData: {
        backup_ttl: function(d) { return "Original (infected) file will be removed"; },
        cleaned_at: function(d) { return "Cleaned"; },
        ctime: function(d) { return "ctime"; },
        modified: function(d) { return "Modified"; },
        scanType: function(d) { return "Scan type"; },
        snippet: function(d) { return "Malicious snippet"; }
      },
      headers: {
        detectionDate: function(d) { return "Scan date"; },
        malicious: function(d) { return "Malicious"; },
        reason: function(d) { return "Reason"; },
        scanType: function(d) { return "Scan type"; },
        status: function(d) { return "Status"; },
        user: function(d) { return "Username"; }
      },
      no: function(d) { return "No"; },
      quarantineCleanupWarning: function(d) { return "Any quarantined files will be restored from quarantine during cleanup."; },
      quarantineCleanupWarning_2: function(d) { return "Any quarantined files/DB will be restored from quarantine during cleanup."; },
      scanAll: function(d) { return "Scan all"; },
      status: {
        cleanup_done: function(d) { return "Cleaned"; },
        cleanup_removed: function(d) { return "Content removed"; },
        cleanup_requires_myimunify_protection: function(d) { return "Infected (Advanced)"; },
        cleanup_started: function(d) { return "Cleanup in progress"; },
        cleanup_pending: function(d) { return "Cleanup in progress"; },
        restore_from_backup_started: function(d) { return "Restore from backup in progress"; },
        cleanup_restore_started: function(d) { return "Restore from backup in progress"; },
        found: function(d) { return "Infected"; },
        infected: function(d) { return "Infected"; },
        quarantined: function(d) { return "Quarantined"; }
      },
      subtitle: function(d) { return "Malware detected by " + d.productName; },
      title: function(d) { return "Malicious " + plural(d.count, 0, en, { "0": "", other: "(" + number(d.count, "count") + ")" }); },
      yes: function(d) { return "Yes"; }
    },
    onDemand: {
      advanced: function(d) { return "Advanced"; },
      featuresDisabled: function(d) { return "Some features of real-time scan are disabled because of conflicts."; },
      filenameMask: function(d) { return "Filename mask"; },
      folderToScan: function(d) { return "Folder to scan:"; },
      followSymlinks: function(d) { return "Follow symlinks"; },
      headers: {
        path: function(d) { return "Path"; },
        result: function(d) { return "Result"; },
        started: function(d) { return "Scan date"; },
        total: function(d) { return "Total objects"; },
        totalTooltip: function(d) { return "Total objects scanned"; },
        viewResults: function(d) { return "View results"; }
      },
      ignoreMask: function(d) { return "Ignore mask"; },
      links: {
        malicious: function(d) { return "Malicious"; },
        history: function(d) { return "History"; },
        ignoreList: function(d) { return "Ignore list"; },
        onDemandScan: function(d) { return "Scan"; },
        userList: function(d) { return "Users"; }
      },
      needAction: function(d) { return d.count + " still infected"; },
      notifications: {
        scannerStopped: function(d) { return "Malware on-demand scanner stopped"; },
        youCanSeeResults: function(d) { return "You can see results"; }
      },
      scannerStopped: function(d) { return "Scanner is stopped"; },
      scannerStoppedEndUser: function(d) { return "Real-time scanner is ON"; },
      AutomaticallyScanTooltip: function(d) { return "Automatically scan all modified files"; },
      scanning: function(d) { return "Scanning..."; },
      severalPatternsFilename: function(d) { return "Several patterns can be added in Filename mask with \", \" delimiter.\nExample:\n/home/*/mail/, /home/*/tmp, *.php"; },
      severalPatternsIgnore: function(d) { return "Several patterns can be added in Ignore mask with \", \" delimiter.\nExample:\n/home/*/mail/, /home/*/tmp, *.php"; },
      start: function(d) { return "START"; },
      status: {
        filenameMask: function(d) { return "Filename mask:"; },
        folder: function(d) { return "Folder:"; },
        ignoreMask: function(d) { return "Ignore mask:"; },
        running: function(d) { return "Running With Parameters"; },
        status: function(d) { return "Status:"; },
        "status-background": function(d) { return "Scheduled scan status:"; },
        "status-on-demand": function(d) { return "On-Demand scan status:"; },
        "status-user": function(d) { return "User's scan status:"; },
        stopped: function(d) { return "Stopped"; }
      },
      stop: function(d) { return "STOP"; },
      viewDetails: function(d) { return "View details."; },
      userScan: {
        start: function(d) { return "Start scanning"; },
        stop: function(d) { return "Stop scanning"; },
        inProgress: function(d) { return "Scanning in progress..."; },
        queued: function(d) { return "Scanning queued..."; }
      }
    },
    title: function(d) { return "Malware scanner"; },
    upgradeWarning: {
      warning: function(d) { return "Your server is infected. Do you want to |clean it up|?"; },
      title: function(d) { return "Cleanup " + plural(d.count, 0, en, { one: "file", other: "files" }); },
      description: function(d) { return "Do you want to perform automatic 1-click cleanup or do you want to cleanup files manually?"; },
      notice: function(d) { return "Manual cleanup will require some OS, programming, and anti-malware skills."; },
      manual: function(d) { return "Manual cleanup"; },
      auto: function(d) { return "Auto cleanup"; }
    },
    userList: {
      cleanAction: function(d) { return "Clean up files"; },
      cleanup: function(d) { return "Clean up"; },
      cleanupModal: {
        confirmText: function(d) { return "yes, clean up"; },
        title: function(d) { return "Clean up " + plural(d.count, 0, en, { one: "user's", other: "users'" }) + " files"; }
      },
      filterAction: function(d) { return "View report"; },
      headers: {
        home: function(d) { return "Home directory"; },
        infected: function(d) { return "Infection status"; },
        operation: function(d) { return "Operation status"; },
        user: function(d) { return "Username"; },
        scanDate: function(d) { return "Scan date"; }
      },
      notAllowed: function(d) { return "Action is not allowed"; },
      reportAction: function(d) { return "Show report"; },
      restore: function(d) { return "Restore"; },
      restoreAction: function(d) { return "Restore original (possibly infected) files"; },
      restoreModal: {
        confirmText: function(d) { return "yes, restore"; },
        title: function(d) { return "Are you sure that you want to restore (possibly infected) copies of " + plural(d.count, 0, en, { one: "this user's", other: "these users'" }) + " files made before cleanup?"; }
      },
      scan: function(d) { return "Scan"; },
      scanModal: {
        confirmText: function(d) { return "yes, scan"; },
        title: function(d) { return "Scan " + plural(d.count, 0, en, { one: "user's", other: "users'" }) + " files"; }
      },
      searchAction: function(d) { return "Scan for malware"; },
      stop: function(d) { return "Stop"; },
      stopAction: function(d) { return "Stop scanning"; },
      stopModal: {
        confirmText: function(d) { return "yes, stop scanning"; },
        title: function(d) { return "Stop scanning " + plural(d.count, 0, en, { one: "user's", other: "users'" }) + " files"; }
      },
      title: function(d) { return "User list"; }
    }
  },
  menu: {
    changeLanguage: function(d) { return "Change Language"; },
    panelLanguage: function(d) { return "Panel Language"; },
    dashboard: function(d) { return "Dashboard"; },
    firewall: function(d) { return "Firewall"; },
    email: function(d) { return "Email"; },
    history: function(d) { return "History"; },
    incidents: function(d) { return "Incidents"; },
    kernelCare: function(d) { return "KernelCare"; },
    logo: function(d) { return "Logo"; },
    logout: function(d) { return "Log out"; },
    lowResourcesUsage: function(d) { return "Low Resource Usage"; },
    malware: function(d) { return "Malware"; },
    malwareScanner: function(d) { return "Malware Scanner"; },
    more: function(d) { return "Show more tabs"; },
    open: function(d) { return "Open menu"; },
    proactiveDefense: function(d) { return "Proactive Defense"; },
    profileMenu: function(d) { return "Profile menu"; },
    reputationManagement: function(d) { return "Reputation Management"; },
    settings: function(d) { return "Settings"; },
    support: function(d) { return "Support"; },
    upgrade: function(d) { return "Upgrade"; },
    helpVideo: function(d) { return "Walkthrough video for Imunify360"; },
    cleanUp: function(d) { return "Clean up"; },
    protectionEnabled: function(d) { return "Protection enabled"; },
    protectionDisabled: function(d) { return "Protection disabled"; },
    packageVersions: function(d) { return "and " + d.count + " more"; }
  },
  news: {
    adminContacts: {
      confirmation: {
        description: function(d) { return "You can edit or remove your email address in "; },
        descriptionLink: function(d) { return "Settings - General - Contact details"; },
        title: function(d) { return "Thank you for submitting your email address"; }
      },
      notificationText: function(d) { return "Our support team can now notify you by email about critical security alerts on your server"; },
      request: {
        emailPlaceholder: function(d) { return "Email@admin.co"; },
        line1: function(d) { return "Our support team can now inform you about critical security events and application misconfigurations on your server."; },
        note: function(d) { return "Please note: We will send only critical security alerts or application misconfiguration warnings to the specified email. We will never use your email for any other type of message."; },
        specifyEmail: function(d) { return "Please enter your email to enable this feature"; },
        specifyEmailHint: function(d) { return "To add several email addresses, separate them with a comma."; },
        title: function(d) { return "Don’t miss important events on your server"; }
      },
      specifyEmail: function(d) { return "Specify email"; }
    },
    attention: function(d) { return "Attention"; },
    fixLicense: function(d) { return "You can fix this issue here"; },
    supportEmail: function(d) { return "Support email:"; },
    takeALook: function(d) { return "Hey, take a look…"; }
  },
  noContent: {
    title: function(d) { return "404: page missing"; }
  },
  notifications: {
    addServerIds: {
      partialFailure: function(d) { return plural(d.count, 0, en, { one: "The entered server key is", other: d.count + " of the entered server keys are" }) + " invalid:"; },
      partialSuccess: function(d) { return plural(d.count, 0, en, { one: "The server was", other: d.count + " servers were" }) + " successfully added to the dashboard:"; }
    },
    cleanup: {
      success: function(d) { return "Cleanup initiated"; }
    },
    cleanupInitiated: function(d) { return "Cleanup started"; },
    countryAction: function(d) { return plural(d.count, 0, en, { one: "Country", other: "Countries" }) + " " + plural(d.count, 0, en, { one: "has", other: "have" }) + " been " + select(d.action, { deleted: "deleted", added: "added", moved: "moved", other: "" }); },
    "delete": {
      partialFailure: function(d) { return "Failed to delete some files:"; },
      partialSuccess: function(d) { return "Deleted files:"; },
      success: function(d) { return "Deleted"; }
    },
    deleted: function(d) { return "Deleted"; },
    details: function(d) { return "Details"; },
    editUserFeatures: {
      notifications: {
        success: function(d) { return select(d.feature, { proactive: "Proactive Defense", av: "Malware Cleanup", webshield: "WebShield", other: "" }) + " feature has been " + select(d.action, { enable: "enabled", disable: "disabled", other: "" }); }
      },
      partialFailure: function(d) { return "Failed to " + d.action + " feature " + select(d.feature, { proactive: "Proactive Defense", av: "Malware Cleanup", webshield: "WebShield", other: "" }) + " for users:"; },
      partialSuccess: function(d) { return select(d.feature, { proactive: "Proactive Defense", av: "Malware Cleanup", webshield: "WebShield", other: "" }) + " feature has been " + select(d.action, { enable: "enabled", disable: "disabled", other: "" }) + " for users:"; }
    },
    error: function(d) { return "Error"; },
    internalError: function(d) { return "Internal Error"; },
    ipAction: function(d) { return plural(d.count, 0, en, { one: "IP", other: "IPs" }) + " " + plural(d.count, 0, en, { one: "has", other: "have" }) + " been " + select(d.action, { deleted: "deleted", added: "added", moved: "moved", updated: "updated", other: "" }); },
    moveToIgnore: {
      failed: function(d) { return "Failed to add to Ignore List"; },
      partialFailure: function(d) { return "Failed to add to Ignore List:"; },
      partialSuccess: function(d) { return "Added to Ignore List:"; },
      success: function(d) { return "Added to Ignore List"; }
    },
    permissionError: function(d) { return "You have no permission to view this file"; },
    generalPermissionError: function(d) { return "You have no permission for this action"; },
    quarantineMalicious: {
      partialFailure: function(d) { return "Failed to quarantine some files:"; },
      partialSuccess: function(d) { return "Quarantined files:"; },
      success: function(d) { return "Added to quarantine"; }
    },
    restoreFromBackup: {
      success: function(d) { return "Restore from backup started"; }
    },
    restoreFromQuarantine: {
      partialFailure: function(d) { return "Failed to restore some files:"; },
      partialSuccess: function(d) { return "Restored files:"; },
      success: function(d) { return "Restored from quarantine"; }
    },
    restoreOriginal: {
      partialFailure: function(d) { return "Some files were not restored:"; },
      partialSuccess: function(d) { return "Restored files:"; },
      success: function(d) { return "Restored"; }
    },
    emails: {
      releaseAction: function(d) { return "The emails were successfully released"; },
      deleteAction: function(d) { return "The emails were successfully deleted"; },
      deleteAccountAction: function(d) { return "The emails were successfully deleted"; },
      updateSpace: function(d) { return "The space was successfully updated"; },
      updateLimit: function(d) { return "The limit was successfully updated"; },
      releasesLimit: function(d) { return "The releases limit was successfully updated"; },
      updateQuarantine: function(d) { return "The Quarantine was successfully updated"; },
      addAccount: function(d) { return "The account was successfully added"; },
      updatedLimit: function(d) { return "The limit was successfully updated"; },
      "add-white-list": function(d) { return "The item was successfully added to white list."; },
      "remove-white-list": function(d) { return "The item was successfully removed from white list."; }
    },
    ruleAction: function(d) { return "Rule has been " + select(d.action, { enabled: "enabled", disabled: "disabled", edited: "edited", other: "" }); },
    scanInitiated: function(d) { return "Scan added to queue"; },
    scanStopped: function(d) { return "Scan removed from queue"; },
    seeLogsForDetails: function(d) { return "See logs for details"; },
    serviceNotStarted: function(d) { return "Imunify service is not started"; },
    versionMismatch: function(d) { return "Versions of UI and agent do not match, page will be reloaded"; },
    success: function(d) { return "Success"; },
    fileNotFound: function(d) { return "File not found!"; },
    warning: function(d) { return "Warning"; },
    warnings: function(d) { return "Warning"; },
    myImunifyPageNotSpecified: function(d) { return "MyImunify purchase page not specified. Please contact your hoster"; }
  },
  pd: {
    addToIgnoreModal: {
      confirm: function(d) { return "yes, add to ignore list"; },
      path: function(d) { return "Path: "; },
      rules: function(d) { return "Rules: "; },
      title: {
        all: function(d) { return "Ignore all rules for those files"; },
        detectedOnly: function(d) { return "Ignore detected rules for those files"; }
      }
    },
    details: {
      blockIp: function(d) { return "Block IP"; },
      environment: function(d) { return "Environment"; },
      headers: {
        name: function(d) { return "Name"; },
        value: function(d) { return "Value"; }
      },
      ignore: {
        all: function(d) { return "Ignore all rules for this file"; },
        detected: function(d) { return "Ignore detected rule for this file"; }
      },
      onlyOne: function(d) { return "There might have been more than one IP, but only one was recorded"; },
      titles: {
        action: function(d) { return "Action:"; },
        ip: function(d) { return "IP:"; },
        numberOfTimes: function(d) { return "Count:"; },
        scriptPath: function(d) { return "Script path:"; },
        time: function(d) { return "Time:"; },
        url: function(d) { return "URL:"; }
      },
      viewFileContent: function(d) { return "View file content"; }
    },
    events: {
      actions: {
        ignoreAll: function(d) { return "Ignore all rules for the file"; },
        ignoreDetected: function(d) { return "Ignore detected rule for the file"; },
        viewDetails: function(d) { return "View details"; },
        viewFileContent: function(d) { return "View file content"; }
      },
      groupActions: {
        ignoreAll: function(d) { return "Ignore all rules"; },
        ignoreDetected: function(d) { return "Ignore detected rules"; }
      },
      headers: {
        action: function(d) { return "Action"; },
        detectionTime: function(d) { return "Detection Date/Time"; },
        host: function(d) { return "Host"; },
        ip: function(d) { return "First script call from"; },
        reason: function(d) { return "Description"; },
        scriptPath: function(d) { return "Script Path"; }
      },
      notifications: {
        successfullyAddedToIgnore: function(d) { return "Added to ignore list"; }
      }
    },
    ignoreList: {
      actions: {
        remove: function(d) { return "Remove from ignore list"; },
        viewFile: function(d) { return "View file content"; }
      },
      allRulesChip: function(d) { return "All rules"; },
      groupActions: {
        remove: function(d) { return "Remove from ignore list"; }
      },
      headers: {
        dateTime: function(d) { return "Add Date/Time"; },
        path: function(d) { return "Script Path"; },
        rules: function(d) { return "Rules to ignore"; },
        username: function(d) { return "Username"; }
      },
      notifications: {
        successfullyRemoved: function(d) { return "Removed from ignore list"; }
      },
      removeModal: {
        confirm: function(d) { return "yes, remove from ignore list"; },
        path: function(d) { return "Path:"; },
        rule: function(d) { return "Rule:"; },
        title: function(d) { return "Remove from ignore list"; }
      }
    },
    mode: {
      modes: {
        descriptions: {
          kill: function(d) { return "Terminate the script as soon as attack is detected. Guarantees the highest level of protection"; },
          log: function(d) { return "Only events logging"; }
        },
        disabled: function(d) { return "Disabled"; },
        kill: function(d) { return "Kill Mode"; },
        log: function(d) { return "Log only"; }
      },
      notifications: {
        changed: function(d) { return "Proactive Defense mode changed to " + select(d.mode, { DISABLED: "DISABLED", LOG: "LOG", BLOCK: "BLOCK", KILL: "KILL", other: "" }); }
      },
      title: function(d) { return "Mode settings"; }
    },
    protectionStatus: {
      malwareProtection: function(d) { return "Malware protection"; },
      protectionEnabled: function(d) { return "Protection enabled"; },
      protectionDisabled: function(d) { return "Protection disabled"; },
      malwareFixed: function(d) { return "Malware fixed"; },
      malwareDetected: function(d) { return "Malware detected"; },
      noMalware: function(d) { return "No malware found"; },
      upgradeToCleanup: function(d) { return "Please upgrade your subscription to clean up."; },
      upgradeToKeepProtected: function(d) { return "To keep your site protected please upgrade your subscription."; },
      on: function(d) { return "ON"; },
      off: function(d) { return "OFF"; }
    },
    navigation: {
      detectedEvents: function(d) { return "Detected Events"; },
      ignoreList: function(d) { return "Ignore List"; }
    },
    subtitle: function(d) { return "Prevents PHP-based attacks"; },
    title: function(d) { return "Proactive Defense"; }
  },
  readMore: {
    readMore: function(d) { return "Read more"; },
    showLess: function(d) { return "Show less"; }
  },
  reputation: {
    affectedDomains: function(d) { return "Affected Domains"; },
    headers: {
      action: function(d) { return "Action"; },
      detectionTime: function(d) { return "Detection time"; },
      domain: function(d) { return "Domain"; },
      id: function(d) { return "ID"; },
      type: function(d) { return "Threat type"; },
      vendor: function(d) { return "Vendor"; }
    },
    threatType: {
      MALWARE: function(d) { return "Malware"; },
      SOCIAL_ENGINEERING: function(d) { return "Social Engineering"; },
      UNWANTED_SOFTWARE: function(d) { return "Unwanted software"; },
      THREAT_TYPE_UNSPECIFIED: function(d) { return "Unspecified"; },
      POTENTIALLY_HARMFUL_APPLICATION: function(d) { return "Potentially harmful application"; },
      "spam domain": function(d) { return "Spam"; },
      "phish domain": function(d) { return "Phishing"; },
      "malware domain": function(d) { return "Malware"; },
      "botnet C&C domain": function(d) { return "Botnet C&C"; },
      "abused legit spam": function(d) { return "Abused legit spam"; },
      "abused spammed redirector domain": function(d) { return "Abused spammed redirector"; },
      "abused legit phish": function(d) { return "Abused legit phishing"; },
      "abused legit malware": function(d) { return "Abused legit malware"; },
      "abused legit botnet C&C": function(d) { return "Abused legit botnet C&C"; },
      ANY: function(d) { return "Unspecified"; }
    },
    title: function(d) { return "Reputation Management"; },
    infoAction: function(d) { return "View action guide"; }
  },
  settings: {
    backup: {
      component: {
        backupAndRestore: function(d) { return "Backup and restore"; },
        choose: function(d) { return "Choose"; },
        chooseProvider: function(d) { return "Choose backup provider"; },
        description: function(d) { return "This feature allows " + d.productName + " to restore clean version of malicious and suspicious files from backup"; },
        disabled: function(d) { return "Disabled"; },
        enabled: function(d) { return d.backupSystem + " enabled"; },
        manageBackups: function(d) { return "Manage Backups"; }
      },
      connectBackup: function(d) { return "Connect Backup"; },
      credentials: {
        activationInProgress: function(d) { return "Activation in progress..."; },
        password: function(d) { return "Password"; },
        username: function(d) { return "Username"; }
      },
      disableModal: {
        body: function(d) { return "This feature allows " + d.productName + " to restore clean version of malicious and suspicious files from backup."; },
        confirmText: function(d) { return "yes, disable backup"; },
        destroy: function(d) { return "Destroy permanently all backups of this server and deactivate CloudLinux Backup in CLN"; },
        title: function(d) { return "Disable " + d.backupSystem + "?"; },
        warning: function(d) { return "Do you really want to disable backup integration?"; }
      },
      schedule: {
        noSchedule: function(d) { return "No schedule! Click \"Manage backups\" to configure backup schedule."; }
      },
      systems: {
        acronis: {
          current: function(d) { return "Current Acronis account"; },
          description: function(d) { return "Choose this if you have Acronis account and have already activated Acronis backup agent. (Allows " + d.productName + " to use Acronis backups to search for clean versions of infected files on your server.)"; },
          existing: function(d) { return "Connect with existing Acronis account"; }
        },
        cl: {
          bonus: function(d) { return "GET 10GB FOR FREE"; },
          connect: function(d) { return "Connect with CloudLinux account"; },
          getGbs: function(d) { return "and get 10GB for free"; },
          resize: function(d) { return "Resize"; },
          titles: {
            region: function(d) { return "Backup server region"; },
            size: function(d) { return "Backup storage size"; }
          },
          used: function(d) { return "Used: " + d.used + "GB, Total: " + d.total + "GB"; }
        },
        clPremise: {
          connect: function(d) { return "Connect with CloudLinux Backup On-Premises"; },
          current: function(d) { return "Current CloudLinux Backup On-Premises account"; },
          description: function(d) { return "Choose this if you have already installed CloudLinux Backup On-Premises."; },
          support: function(d) { return "Contact|support|to get CloudLinux Backup On-Premises installed."; }
        },
        local: {
          connect: function(d) { return "Connect to local backup"; }
        },
        notifications: {
          activation: function(d) { return "Activation in progress..."; },
          configured: function(d) { return "Backup configured"; },
          disabled: function(d) { return "Backup disabled"; },
          errorDuringStage: function(d) { return "Error during \"" + select(d.state, { done: "done", init: "init", backup: "backup", not_running: "not_running", activation: "activation", other: "" }) + "\" stage"; },
          installing: function(d) { return "Activated, installing..."; },
          windowClosed: function(d) { return "Order window was closed"; }
        }
      }
    },
    blockedRules: {
      addForm: {
        description: function(d) { return "Description"; },
        domains: function(d) { return "Domains"; },
        domainsNote: function(d) { return "Comma-separated list of domains for which this rule will be disabled. Leave empty to disable for all domains."; },
        id: function(d) { return "Rule ID"; },
        plugin: function(d) { return "Plugin"; }
      },
      allDomains: function(d) { return "all"; },
      domainsNotAllowed: function(d) { return "N/A"; },
      emptyMessage: function(d) { return "You can disable rules from the|Incidents|tab"; },
      enable: function(d) { return "Enable"; },
      enableModal: {
        body: function(d) { return "Rule|will be enabled."; },
        title: function(d) { return "Are you sure?"; }
      },
      headers: {
        actions: function(d) { return "Actions"; },
        description: function(d) { return "Description"; },
        domains: function(d) { return "Domains"; },
        domainsTooltip: function(d) { return "The list of domains for which rule is disabled"; },
        id: function(d) { return "Rule ID"; },
        plugin: function(d) { return "Plugin"; }
      }
    },
    component: {
      backupInProgress: function(d) { return "Backup in progress..."; },
      mysqlFrozen: function(d) { return "MySQL will be frozen during backup. Processes that use it (plesk, etc.) may be temporarily unavailable."; }
    },
    feature: {
      modal: {
        confirmTextInstall: function(d) { return "Yes, install"; },
        confirmTextRemove: function(d) { return "Yes, remove"; },
        title: function(d) { return "Are you sure?"; },
        willBeInstalled: function(d) { return d.feature + "|will be installed"; },
        willBeRemoved: function(d) { return d.feature + "|will be removed"; }
      },
      lve: {
        installed: function(d) { return "HardenedPHP is managed in the |LVE manager|"; },
        notInstalled: function(d) { return "Install the |LVE manager| to manage HardenedPHP"; }
      },
      titles: {
        install: function(d) { return "Install " + d.feature; },
        installing: function(d) { return d.feature + " is installing now..."; },
        remove: function(d) { return "Remove " + d.feature; },
        uninstalling: function(d) { return d.feature + " is uninstalling now..."; }
      }
    },
    featuresManagement: {
      cleanup: function(d) { return "Malware Cleanup"; },
      description: function(d) { return "Here you can enable or disable " + d.productName + " features for each customer."; },
      descriptionNote: function(d) { return "Note: user side UI might be hidden completely - use /usr/share/av-userside-plugin.sh to enable it."; },
      domains: function(d) { return "Domains"; },
      headerDescription: function(d) { return "Default for new users"; },
      hideDomains: function(d) { return "Hide domains"; },
      name: function(d) { return "Name"; },
      newFeaturesManagement: {
        action: function(d) { return "Agree and Switch"; },
        featuresManagementDisabled: {
          descriptionRest: function(d) { return "in | Edit a Package | for a specific package, in | List Accounts -> Modify Account | , or via | cPanel API"; },
          packageExtensions: {
            description: function(d) { return "All user features can be configured"; },
            title: function(d) { return "You have activated Feature Management using WHM/cPanel package extensions"; }
          },
          myImunify: {
            description: function(d) { return "You can |configure your billing system |to automatically enable MyImunify Account Protection for users who purchased it"; },
            title: function(d) { return "The access to Imunify" + d.packageName + " features is now defined by MyImunify Account Protection status"; }
          }
        },
        modalText: {
          "modalText-1": function(d) { return "This option will switch to a new Feature Management using WHM/cPanel package extensions. It will turn off original Imunify" + d.packageName + " Feature Management and create Imunify" + d.packageName + " package extensions for each existing package in WHM/cPanel"; },
          "modalText-2": function(d) { return "Please note (!) | Imunify" + d.packageName + " Feature Management UI is not available after switching to WHM/cPanel package extensions."; },
          "modalText-3": function(d) { return "Current Imunify" + d.packageName + " Features Management user settings will be reset to the following default values: | Malware Scanner - View Reports Only | Proactive Defense - Available. Log Only Mode"; },
          "modalText-4": function(d) { return "You can configure them anytime under WHM «Edit a Package» menu or via cPanel API."; }
        },
        supportedText: function(d) { return "A new version of Features Management is now available via WHM/cPanel package extension."; }
      },
      proactive: function(d) { return "Proactive Defense"; },
      selectedItems: function(d) { return plural(d.count, 0, en, { one: "1 item selected", other: number(d.count, "count") + " items selected" }); },
      showDomains: function(d) { return "Show all " + d.size + " domains"; },
      webshield: function(d) { return "WebShield"; }
    },
    general: {
      adminContacts: {
        email: {
          description: function(d) { return "This will be used by our support team to inform you about critical security alerts on your server"; },
          label: function(d) { return "Email"; }
        },
        groupName: function(d) { return "Contact details"; }
      },
      autoWhiteList: {
        groupName: function(d) { return "Auto White List"; },
        timeout: {
          descriptions: {
            permanently: function(d) { return "\"0\" - add permanently"; },
            removed: function(d) { return "Number of minutes after which IP will be removed from white list."; }
          },
          label: function(d) { return "Timeout"; }
        }
      },
      dos: {
        checkDelay: {
          descriptions: function(d) { return "Period in seconds between each DoS detection check. Limited by the min value of 30, lower values cause “false positives” triggering."; },
          label: function(d) { return "Check delay"; }
        },
        enableDos: function(d) { return "Connection-based DoS Protection"; },
        groupName: function(d) { return "DoS Protection"; },
        maxConnections: {
          descriptions: function(d) { return "Max simultaneous connections before IP is blocked"; },
          label: function(d) { return "Max Connections"; }
        }
      },
      myImunify: {
        enable: {
          label: function(d) { return "Enable MyImunify"; },
          description: function(d) { return "Sell additional Imunify features to users."; }
        },
        enableForAll: {
          label: function(d) { return "Enable protection for all users"; }
        },
        purchasePageUrl: {
          label: function(d) { return "Your billing system host"; },
          description: function(d) { return "For example: https://whmcs.example.com/"; }
        },
        groupName: function(d) { return "MyImunify"; }
      },
      smtpBlocking: {
        groupName: function(d) { return "SMTP Traffic Management"; },
        enable: {
          label: function(d) { return "Enable SMTP Traffic Management"; },
          description: function(d) { return "When enabled the outgoing SMTP traffic would be blocked according to the settings below."; }
        },
        ports: {
          label: function(d) { return "SMTP Ports"; },
          description: function(d) { return "The comma-separated list of the SMTP ports to be blocked."; }
        },
        allowUsers: {
          label: function(d) { return "Allow users"; },
          description: function(d) { return "The comma-separated list of the unix users to be whitelisted from SMTP blocks."; }
        },
        allowGroups: {
          label: function(d) { return "Allow groups"; },
          description: function(d) { return "The comma-separated list of the unix groups to be whitelisted from SMTP blocks."; }
        },
        allowLocal: {
          label: function(d) { return "Allow local"; },
          description: function(d) { return "Enable to allow local SMTP connections on the server."; }
        },
        redirect: {
          label: function(d) { return "Redirect to local"; },
          description: function(d) { return "When enabled the outgoing mail traffic would be redirected to the local ports."; }
        }
      },
      errorReporting: {
        enableSentry: {
          descriptions: function(d) { return "Send reports to " + d.productName + " error report server"; },
          label: function(d) { return "Enable Sentry error reporting"; }
        },
        groupName: function(d) { return "Error reporting"; }
      },
      incidentsLogging: {
        autoRefresh: {
          descriptions: function(d) { return "Number of seconds"; },
          label: function(d) { return "Auto-refresh time for Incidents page"; }
        },
        groupName: function(d) { return "Incidents logging"; },
        keepCount: function(d) { return "Keep maximum incidents count"; },
        keepIncidents: function(d) { return "Keep incidents for the last days"; },
        logLevel: {
          descriptions: function(d) { return "Minimal level of logs that will be shown in incidents"; },
          label: function(d) { return "Log level"; },
          modsec: function(d) { return "mod security:"; },
          ossec: function(d) { return "OSSEC:"; },
          sliderTitle: function(d) { return "Log level:"; }
        },
        sendAdditional: {
          descriptions: function(d) { return "Send obfuscated sensitive data to the central server."; },
          title: function(d) { return "Send additional data"; }
        }
      },
      installation: {
        groupName: function(d) { return "Installation"; },
        hardenedPhp: {
          description: function(d) { return "Automatically patches old PHP versions to include backport fixes."; },
          label: function(d) { return "Hardened PHP"; }
        },
        kernelCare: {
          description: function(d) { return "Automated kernel security updates without reboots."; },
          label: function(d) { return "KernelCare"; }
        },
        more: function(d) { return "More..."; }
      },
      logLevels: {
        "1": function(d) { return "None"; },
        "2": function(d) { return "System low priority notification"; },
        "3": function(d) { return "Successful/Authorized events"; },
        "4": function(d) { return "System low priority error"; },
        "5": function(d) { return "User-generated error"; },
        "6": function(d) { return "Low relevance attack"; },
        "7": function(d) { return "“Bad word” matching"; },
        "8": function(d) { return "First time seen"; },
        "9": function(d) { return "Error from invalid source"; },
        "10": function(d) { return "Multiple user generated errors"; },
        "11": function(d) { return "Integrity checking warning"; },
        "12": function(d) { return "High importance event"; },
        "13": function(d) { return "Unusual error"; },
        "14": function(d) { return "High importance security event"; },
        "15": function(d) { return "Severe attack"; }
      },
      modSecLevels: {
        "0": function(d) { return "EMERGENCY - is generated from correlation of anomaly scoring data where there is an inbound attack and an outbound leakage"; },
        "1": function(d) { return "ALERT - is generated from correlation where there is an inbound attack and an outbound application level error"; },
        "2": function(d) { return "CRITICAL - Anomaly Score of 5. Is the highest severity level possible without correlation. It is normally generated by the web attack rules (40 level files)"; },
        "3": function(d) { return "ERROR - Anomaly Score of 4. Is generated mostly from outbound leakage rules (50 level files)"; },
        "4": function(d) { return "WARNING - Anomaly Score of 3. Is generated by malicious client rules (35 level files)"; },
        "5": function(d) { return "NOTICE - Anomaly Score of 2. Is generated by the Protocol policy and anomaly files"; },
        "6": function(d) { return "INFO"; },
        "7": function(d) { return "DEBUG"; }
      },
      ossec: {
        active_response: {
          description: function(d) { return "Active Response is an OSSEC-driven (IDS) feature of Imunify360 which has been re-engineered to make it capable of blocking access to a specific server port being attacked. \nThe purpose of the feature is significantly reducing false positive rate while increasing its capabilities to detect and block aggressive brute force requests."; },
          label: function(d) { return "Active response"; }
        },
        groupName: function(d) { return "OSSEC"; }
      },
      csfIntegration: {
        catch_lfd_events: {
          description: function(d) { return "Lets Imunify360 manage CSF events and IP lists"; },
          label: function(d) { return "Manage CSF Events and Lists"; }
        },
        groupName: function(d) { return "3-rd Party Integration"; }
      },
      webshield: {
        groupName: function(d) { return "WebShield"; },
        warningRequire: function(d) { return "Requires WebShield"; },
        enable: {
          label: function(d) { return "Enable WebShield"; },
          description: function(d) { return "When the option is off, WebShield and GreyList are disabled. A disabled state is recommended for the servers with a small amount of RAM. A disabled option along with enabled \"Minimized WAF Ruleset\" will switch Imunify360 to the \"Low Resource Usage\" mode."; }
        },
        known_proxies_support: {
          description: function(d) { return "Allows to recognize and block IPs with suspicious activity behind CloudFlare and MaxCDN"; },
          label: function(d) { return "Detect IPs behind CDN"; }
        },
        splash_screen: {
          description: function(d) { return "Show JavaScript challenge page to the visitors with suspicious IPs in order to verify whether they are bots or humans. Will drastically reduce server load and will not affect legitimate bots e.g. search bots, CDN providers and similar."; },
          note: function(d) { return " This feature will require an additional 20MB of RAM."; },
          label: function(d) { return "Anti-bot protection"; }
        },
        panel_protection: {
          label: function(d) { return "cPanel account protection"; },
          description: function(d) { return "Show JavaScript challenge to any user trying to access hosting panel interface. It will prevent bots from compromising and using the account.\n Note: legitimate automation services that access web UI/API must be whitelisted manually."; }
        }
      },
      pam: {
        groupName: function(d) { return "PAM"; },
        enable: {
          label: function(d) { return "PAM brute-force attack protection"; },
          description: function(d) { return "This feature enables an advanced brute-force protection technique based on the combination of PAM module authorization, RBL check and IP blacklisting."; }
        },
        eximDovecotProtection: {
          label: function(d) { return "Exim+Dovecot brute-force attack protection"; },
          description: function(d) { return "This feature enables advanced protection against Dovecot brute-force attacks."; }
        },
        ftpProtection: {
          label: function(d) { return "FTP brute-force attack protection"; },
          description: function(d) { return "This feature enables advanced protection against FTP brute-force attacks."; },
          warningMoreText: function(d) { return "Check Imunify360 documentation for details."; }
        }
      },
      mod_sec: {
        groupName: function(d) { return "WAF Settings"; },
        appSpecificRuleset: {
          label: function(d) { return "Apply CMS-specific WAF Rules"; },
          description: function(d) { return "Domain rules are applied based on detected content management systems (WordPress, Joomla, Drupal, etc)\nand their plugins. It allows making WAF rules more effective to protect websites and reduce the number of false positives.\nAll changes (new or removed domains, new or removed content management systems) are applied within a day.\nWhen disabled, the default Imunify360 WAF rules are applied to all domains."; }
        },
        ruleSet: {
          label: function(d) { return "Minimized ModSec Ruleset"; },
          description: function(d) { return "When this option is on, Imunify WAF rules with a high memory footprint are disabled, but critical ruleset is enabled. It will significantly reduce memory usage. Recommended for the servers with a small amount of RAM. An enabled option along with disabled WebShield will switch Imunify360 to the \"Low Resource Usage\" mode."; }
        },
        wordPressAccountCompromise: {
          label: function(d) { return "WordPress Account Compromise Prevention"; },
          description: function(d) { return "This option enables a security setting for WordPress websites when users use weak account passwords listed in brute-force vocabulary. It takes a user that is trying to log in to WordPress onto a special page with an alert message and forces to reset a password to prevent unauthorized account use."; },
          warning: function(d) { return "This switch disables “Weak password login prevention” and allows to use weak passwords, but it does not disable heuristics level protection for the compromised accounts."; }
        }
      },
      genericUserNotifications: {
        label: function(d) { return "Enable email notifications about security issues affecting the account"; },
        description: function(d) { return "Allow Imunify to send messages about issues requiring attention, e.g. compromised account password."; },
        linkLabel: function(d) { return "Read more..."; }
      }
    },
    malware: {
      cleanup: {
        groupName: function(d) { return "Cleanup"; },
        keepOriginalFilesDays: {
          days: function(d) { return "days"; },
          label: function(d) { return "Keep original files for"; }
        },
        trimFiles: function(d) { return "Trim file instead of remove"; },
        description: function(d) { return "Truncate a file instead of removal, making it zero-length."; }
      },
      general: {
        backupMaxDays: function(d) { return "Use backups not older than (days)"; },
        defaultAction: {
          label: function(d) { return "Default action on detect"; },
          options: {
            notify: function(d) { return "Just display in dashboard"; },
            cleanup: function(d) { return "Cleanup"; }
          },
          placeholder: function(d) { return "Choose default action"; }
        },
        rapidScan: {
          descriptions: function(d) { return "Drastically increases the speed of repetitive scans. It employs cloud-assisted scanning and caches local results so it doesn't have to re-scan unchanged files."; },
          title: function(d) { return "Enable RapidScan"; }
        },
        enableScanCpanel: {
          descriptions: function(d) { return "Adds a layer of security through cPanel File Manager. Blocks malicious file upload attempts as well as prevents malicious content to be added to the legitimate files."; },
          label: function(d) { return "Block malicious file uploads via cPanel File Manager"; }
        },
        enableScanFtp: {
          descriptions: function(d) { return "Requires pure-ftpd"; },
          label: function(d) { return "Automatically scan any file uploaded using ftp"; }
        },
        optimizeRealtimeScan: {
          descriptions: function(d) { return "Try to reduce the system load while watching for file changes in comparison with inotify watch by using fanotify and CloudLinux FileChange API"; },
          label: function(d) { return "Optimize real-time scan"; }
        },
        enableScanInotify: {
          descriptions: function(d) { return "A real-time scan that watches for the file changes in the user home folders and runs malware scanner once a new file or modified one has detected."; },
          label: function(d) { return "Automatically scan all modified files"; }
        },
        enableScanModsec: {
          descriptions: function(d) { return "Requires mod_security"; },
          label: function(d) { return "Automatically scan any file uploaded using web"; }
        },
        groupName: function(d) { return "General"; },
        sendForAnalysis: function(d) { return "Automatically send suspicious and malicious files for analysis"; },
        tryToRestore: {
          descriptions: {
            ifExists: function(d) { return "Restore from backup if clean copy exists."; },
            otherwise: function(d) { return "Otherwise, apply default action"; }
          },
          label: function(d) { return "Try to restore from backup first"; }
        },
        detectElf: {
          label: function(d) { return "Binary (ELF) malware detection"; },
          description: function(d) { return "Search for any binaries (ELF files) in the user home directories and consider them malicious."; }
        },
        crontabs: {
          label: function(d) { return "Enable crontab files scanning"; },
          description: function(d) { return "Scan system and user crontab files for malicious jobs."; }
        },
        hyperscan: {
          label: function(d) { return "Enable Hyperscan"; },
          description: function(d) { return "Use Hyperscan regex engine to greatly improve scanning speed. Note: with this option enabled, scanning may consume up to 50MB of additional RAM."; }
        },
        mdsEnable: {
          label: function(d) { return "Malware Database Scanner"; },
          description: function(d) { return "A database antivirus: automated malware detection and clean-up of WordPress databases."; }
        }
      },
      proactive: {
        blamer: {
          description: function(d) { return "Trace malicious php code execution and report it to CloudLinux to improve " + d.productName + " server protection and malware detection."; },
          title: function(d) { return "Enable blamer"; }
        },
        phpImmunity: {
          description: function(d) { return "Automatically detect & patch vulnerabilities in software at the Proactive Defense level preventing re-infections through the same vulnerability."; },
          title: function(d) { return "PHP Immunity"; }
        },
        groupName: function(d) { return "Proactive Defense"; }
      },
      resourceConsumption: {
        groupName: function(d) { return "Resource consumption"; },
        low: function(d) { return "Low"; },
        high: function(d) { return "High"; },
        cpu: {
          label: function(d) { return "CPU consumption"; },
          descriptions: function(d) { return "Level of CPU usage by Malware Scanner. Please note: low CPU usage means low scanning speed"; }
        },
        io: {
          label: function(d) { return "I/O consumption"; },
          descriptions: function(d) { return "Level of I/O usage by Malware Scanner. Please note: low I/O usage means low scanning speed"; }
        }
      },
      scheduledScanning: {
        groupName: function(d) { return "Background Scanning"; },
        hour: {
          label: function(d) { return "Run at"; },
          placeholder: function(d) { return "Time to run"; }
        },
        interval: {
          label: function(d) { return "Run scanning"; },
          options: {
            day: function(d) { return "Daily"; },
            month: function(d) { return "Monthly"; },
            none: function(d) { return "Never"; },
            week: function(d) { return "Weekly"; }
          },
          placeholder: function(d) { return "Choose periodicity"; }
        },
        monthDay: {
          label: function(d) { return "Day of month to run"; },
          placeholder: function(d) { return "Day of month to run"; }
        },
        weekDay: {
          label: function(d) { return "Run on"; },
          placeholder: function(d) { return "Day of week to run"; }
        }
      }
    },
    notification: {
      emails: {
        label: function(d) { return "Default admin emails"; },
        description: function(d) { return "The default list of emails used for all enabled admin email notifications."; }
      },
      from: {
        label: function(d) { return "From"; },
        description: function(d) { return "Specifies a sender of all emails sent by the Hooks."; }
      },
      groups: {
        realtimeScanMalwareDetected: {
          label: function(d) { return "Real-Time scan: malware detected"; },
          tooltip: function(d) { return "Notification is sent when malware is detected during the real-time scanning"; }
        },
        userScanStarted: {
          label: function(d) { return "User scan: started"; },
          tooltip: function(d) { return "Notification is sent immediately after the user scanning has started"; }
        },
        userScanFinished: {
          label: function(d) { return "User scan: finished"; },
          tooltip: function(d) { return "Notification is sent immediately after the user scanning has finished, regardless the malware has found or not"; }
        },
        customScanStarted: {
          label: function(d) { return "Custom scan: started"; },
          tooltip: function(d) { return "Notification is sent immediately after on-demand (manual) scanning has started"; }
        },
        customScanFinished: {
          label: function(d) { return "Custom scan finished"; },
          tooltip: function(d) { return "Notification is sent immediately after on-demand (manual) scanning has finished, regardless the malware has found or not"; }
        },
        customScanMalwareFound: {
          label: function(d) { return "Custom scan: malware detected"; },
          tooltip: function(d) { return "Notification is sent when the on-demand scanning process has finished and malware found"; }
        },
        userScanMalwareFound: {
          label: function(d) { return "User scan: malware detected"; },
          tooltip: function(d) { return "Notification is sent when the malware scanning process of a user account has finished and malware found"; }
        },
        scriptBlocked: {
          label: function(d) { return "Script blocked"; },
          tooltip: function(d) { return "Notification is sent when the Proactive Defense has blocked malicious script"; }
        }
      },
      fields: {
        adminEmails: {
          label: function(d) { return "Admin emails"; },
          description: function(d) { return "The custom list of emails for the event. These emails will be used along with the default emails for email notifications"; },
          checkboxTitle: function(d) { return "Default admin emails"; }
        },
        enableEmailNotification: {
          label: function(d) { return "Enable email notifications for admin"; },
          description: function(d) { return "Send a notification via email upon event occurrence. It will be sent to the custom list specified below and to the default admin emails when the checkbox \"Default admin emails\" is ON."; }
        },
        notifyEvery: {
          mins: {
            label: function(d) { return "Notify every (mins)"; },
            description: function(d) { return "Notification interval in minutes. The data for all events that happened within the interval will be accumulated and sent altogether."; }
          },
          sec: {
            label: function(d) { return "Notify every (sec)"; },
            description: function(d) { return "Notification interval in seconds. The data for all events that happened within the interval will be accumulated and sent altogether."; }
          }
        },
        enableScriptExecute: {
          label: function(d) { return "Enable script execution"; },
          description: function(d) { return "Run a script (event handler) upon event occurrence."; }
        },
        runScript: {
          label: function(d) { return "Run a script"; },
          description: function(d) { return "The full path to the script(s) or any other Linux executable to be launched on event occurrence. Make sure that the script has an executable bit (+x) on. A line-separated list of scripts is supported."; }
        }
      }
    },
    menu: {
      attributions: function(d) { return "Attributions"; },
      backups: function(d) { return "Backups"; },
      disabledRules: function(d) { return "Disabled rules"; },
      featuresManagement: function(d) { return "Features Management"; },
      general: function(d) { return "General"; },
      malware: function(d) { return "Malware"; },
      notifications: function(d) { return "Notifications"; }
    },
    saveSettings: function(d) { return "Save changes"; },
    successSaveMessage: function(d) { return "Settings saved"; },
    title: function(d) { return "Settings"; }
  },
  warning: {
    scan_pure_ftpd: function(d) { return "Realtime scanning of files uploaded by pure-ftpd is disabled because third-party pure-uploadscript process was detected"; },
    scan_inotify_control_panel: function(d) { return "Inotify scans are disabled because no valid control panel was detected"; },
    scan_inotify_cxswatch_daemon: function(d) { return "Inotify scans are disabled because running cxswatch daemon was detected"; },
    scan_modsec: function(d) { return "Realtime scanning of files uploaded using web is disabled because mod_security is not installed"; },
    csf_dos_protector: function(d) { return "DoS Protection was disabled, because CSF is running"; },
    mod_sec_app_specific_ruleset_apache_v24: function(d) { return "This option is available on the servers running Apache v2.4 and ModSecurity 2"; },
    smtp_blocking_enable: function(d) { return "Conflicts with \"WHM >> SMTP Restrictions\" as native SMTP Traffic Management."; },
    smtp_blocking_kernel_support: function(d) { return "Kernel does not support SMTP blocking"; },
    smtp_blocking_CSF_block: function(d) { return "Imunify360 SMTP blocking feature conflicts with CSF SMTP block"; },
    smtp_blocking_ip6table_nat: function(d) { return "Due to a missing ip6table_nat kernel module this option will only have effect on IPv4 traffic and not on IPv6"; },
    webshield_ssl_cache_not_configured: function(d) { return "WebShield SSL-cache is not configured"; },
    scan_intensity_io_cfq: function(d) { return "This option is effective with CFQ IO scheduler only"; },
    scan_hyperscan_no_ssse3: function(d) { return "Requires SSSE3 CPU instruction set. If you are using QEMU/KVM, make sure you don't use the default or severely outdated CPU model."; },
    scan_hyperscan_el6: function(d) { return "Not supported on CentOS 6."; },
    pam_ftp_not_available: function(d) { return "This feature is not available in the current configuration of the FTP server."; },
    set_by_admin: function(d) { return "This value is set by server administrator"; },
    php_immunity_enabled: function(d) { return "Forcibly turned on for PHP Immunity. Turn off PHP Immunity first to make it configurable"; },
    "stand-alone": {
      title: function(d) { return "Internal Error"; },
      "error-description": function(d) { return "Ensure the Imunify installation is configured correctly. See |documentation."; },
      socketError: function(d) { return "Socket files are not accessible, possibly due to lack of access rights"; }
    }
  },
  support: {
    attachments: function(d) { return "Attachments"; },
    cln: {
      description: function(d) { return "Please fill in your CLN account name. Put NONE if not applicable"; },
      placeholder: function(d) { return "CLN account"; },
      title: function(d) { return "CLN account (optional)"; }
    },
    description: {
      description: function(d) { return "Please enter the details of your request. A member of our support staff will respond as soon as possible"; },
      placeholder: function(d) { return "Description"; },
      title: function(d) { return "Description"; }
    },
    email: {
      placeholder: function(d) { return "Your email address"; },
      title: function(d) { return "Your email address"; }
    },
    subject: {
      placeholder: function(d) { return "Subject"; },
      title: function(d) { return "Subject"; }
    },
    submit: function(d) { return "Submit"; },
    success: {
      link: function(d) { return "Here is the direct link:"; },
      subtitle: function(d) { return "You will shortly receive a mail with further information."; },
      title: function(d) { return "Request has been successfully sent to support."; },
      checkEmail: function(d) { return "Check your email inbox please, to get the link to the ticket!"; }
    },
    title: function(d) { return "Contact support"; }
  },
  tooltips: {
    clickToCopyDomain: function(d) { return "Click to copy domain to clipboard"; },
    ipAdd: function(d) { return "Example: 1.2.3.4, 1.2.3.0/24, 1111:2222:3333:4444::/64, 1111:2222:3333::/48"; }
  },
  upgrade: {
    av: {
      title: function(d) { return "Antivirus Plus"; },
      titleInDescription: function(d) { return "No PRO skills required"; },
      description: function(d) { return "For reliable, one-click cleanup of\n malware-infected files, upgrade to ImunifyAV+"; },
      benefits: {
        malwareDetection: function(d) { return "Signature-based and heuristics-based malware detection"; },
        malwareCleanup: function(d) { return "One-click malware cleanup"; },
        scheduledScanning: function(d) { return "Scheduled scanning"; }
      }
    },
    im360: {
      title: function(d) { return "All-in-one security suite:\nAntivirus and Real-time Server Protection"; },
      description: function(d) { return "Automated malware clean-up\nProtect websites from hacks and blacklisting"; },
      fullProtection: function(d) { return "full protection"; },
      includes: function(d) { return "includes"; },
      benefits: {
        realTimeExecutions: function(d) { return "Proactive Defense to block php\n malicious executions in the real-time"; },
        stopBots: function(d) { return "Stop bad bots and SPAM comments"; },
        outdatedAndSoftware: function(d) { return "KernelCare, HardenedPHP, Web Application Firewall protects outdated and vulnerable software"; },
        comprehensiveSecurity: function(d) { return "Comprehensive security out of the box"; },
        professionalSupport: function(d) { return "24/7 professional support"; }
      }
    },
    readMore: function(d) { return "Read more"; },
    buyButton: function(d) { return "Buy now"; }
  },
  upgradeNeeded: {
    title: function(d) { return select(d.name, { firewall: "Firewall", pd: "Proactive defense", kernelcare: "KernelCare", other: "" }) + " integration is available in Imunify360 only"; },
    reputationManagementTitle: function(d) { return "Reputation management integration is available in ImunifyAV+ only"; },
    upgrade: function(d) { return "Upgrade Imunify"; },
    firewall: function(d) { return "Upgrade to protect against known web attacks."; },
    pd: function(d) { return "Upgrade to resist known and new web attacks proactively."; },
    reputationManagement: function(d) { return "Upgrade to track the reputation of web sites before it affects ranking for search engines, e.g. Google."; },
    kernelcare: function(d) { return "Upgrade to improve uptime of the server and protect against Kernel vulnerabilities."; }
  },
  userside: {
    bigWarning: {
      body: function(d) { return d.count + " files were infected and quarantined due to last malware scan. It is necessary to fix problems as they can not be fixed automatically. List of files on the|Dashboard"; },
      title: function(d) { return "Warning!"; }
    },
    history: {
      malware: {
        events: {
          added_to_ignore: function(d) { return "Added to Ignore List"; },
          cleanup_done: function(d) { return "Cleaned"; },
          cleanup_pending: function(d) { return "Cleanup in progress"; },
          cleanup_removed: function(d) { return "Cleanup removed content"; },
          cleanup_started: function(d) { return "Cleanup started"; },
          deleted: function(d) { return "Deleted permanently"; },
          deleted_from_ignore: function(d) { return "Deleted from Ignore List"; },
          failed_to_cleanup: function(d) { return "Cleanup failed"; },
          failed_to_delete: function(d) { return "Failed to delete"; },
          failed_to_delete_from_ignore: function(d) { return "Failed to delete from Ignore List"; },
          failed_to_ignore: function(d) { return "Failed to add to Ignore List"; },
          failed_to_quarantine: function(d) { return "Failed to quarantine"; },
          failed_to_restore_from_backup: function(d) { return "Failed to restore from backup"; },
          failed_to_restore_from_quarantine: function(d) { return "Failed to restore from quarantine"; },
          failed_to_restore_original: function(d) { return "Failed to restore original"; },
          failed_to_store_original: function(d) { return "Failed to store original"; },
          found: function(d) { return "Detected as malicious"; },
          quarantined: function(d) { return "Quarantined"; },
          restored_from_backup: function(d) { return "Successfully restored from backup"; },
          requires_myimunify_protection: function(d) { return "Infected (Advanced)"; },
          restored_from_quarantine: function(d) { return "Restored from quarantine"; },
          restored_original: function(d) { return "Restored original"; },
          submitted_for_analysis: function(d) { return "Submitted for analysis"; },
          unable_to_cleanup: function(d) { return "Unable to clean up"; }
        },
        headers: {
          cause: function(d) { return "Cause"; },
          date: function(d) { return "Date"; },
          event: function(d) { return "Event"; },
          eventTooltip: function(d) { return "Search by event"; },
          initiator: function(d) { return "Initiator"; },
          initiatorTooltip: function(d) { return "User, who caused the Event by performing a direct action, or by configuring automated behavior in Settings."; },
          owner: function(d) { return "Owner"; },
          ownerTooltip: function(d) { return "Search by owner"; },
          path: function(d) { return "Path"; },
          pathTooltip: function(d) { return "Search by path"; }
        },
        owner: function(d) { return "Owner"; }
      },
      menu: {
        cleanupRequestHistory: function(d) { return "Clean up request history"; },
        malwareHistory: function(d) { return "Malware history"; }
      },
      title: function(d) { return "History"; }
    },
    my_imunify_payment_success_modal: {
      details: function(d) { return "Payment has been successfully accepted, expect Protection to be activated soon."; }
    }
  },
  utils: {
    experimentalLabel: function(d) { return "Experimental"; },
    addItemForm: {
      add: {
        Country: function(d) { return "Add country"; },
        IP: function(d) { return "Add IP"; },
        Port: function(d) { return "Add port"; },
        Rule: function(d) { return "Add rule"; },
        Account: function(d) { return "Add Account"; }
      },
      cancel: function(d) { return "cancel"; },
      headers: {
        Country: function(d) { return "Country"; },
        IP: function(d) { return "IP"; },
        Port: function(d) { return "Port"; },
        Rule: function(d) { return "Rule"; },
        Account: function(d) { return "Add Account in Quarantine"; }
      },
      open: function(d) { return "add"; },
      addInline: {
        white: function(d) { return "Add to white list"; },
        black: function(d) { return "Add to black list"; },
        drop: function(d) { return "Add to drop list"; }
      }
    },
    appState: {
      running: function(d) { return "running"; },
      stopped: function(d) { return "stopped"; }
    },
    copyOnClick: {
      click: function(d) { return "Click to copy to clipboard"; },
      copied: function(d) { return "Successfully copied to clipboard"; },
      manually: function(d) { return "Copy to clipboard:\nSelect, Cmd+C, Enter"; }
    },
    csf: {
      note: function(d) { return "Please|use csf|to manage " + select(d.listName, { blocked_ports: "ports", other: "" }) + "."; },
      title: function(d) { return "Disable CSF to allow " + select(d.listName, { blocked_ports: "ports", other: "" }) + " management."; }
    },
    datepicker: {
      days: function(d) { return "Days"; },
      hours: function(d) { return "Hours"; },
      placeholder: function(d) { return "Enter TTL"; }
    },
    fileUploader: {
      attach: function(d) { return "Attach files|or drag to here"; }
    },
    inlineDatepicker: {
      remove: function(d) { return "Remove"; },
      save: function(d) { return "Save"; }
    },
    modals: {
      confirm: {
        confirms: {
          cleanup: function(d) { return "yes, clean up"; },
          "cleanup-all": function(d) { return "yes, clean up"; },
          "delete": function(d) { return "yes, delete"; },
          "delete-from-black": function(d) { return "yes, remove from black list"; },
          "delete-ip": function(d) { return "yes, remove"; },
          "delete-from-white": function(d) { return "yes, remove from white list"; },
          "delete-ip-from-port": function(d) { return "yes, delete permanently"; },
          "delete-port": function(d) { return "yes, delete permanently"; },
          "disable-av": function(d) { return "yes, disable"; },
          "disable-av-default": function(d) { return "yes, disable for new users"; },
          "disable-proactive": function(d) { return "yes, disable proactive"; },
          "disable-proactive-default": function(d) { return "yes, disable proactive for new users"; },
          "disable-webshield": function(d) { return "yes, disable WebShield"; },
          "disable-webshield-default": function(d) { return "yes, disable WebShield for new users"; },
          done: function(d) { return "Done"; },
          "enable-av": function(d) { return "yes, enable"; },
          "enable-av-default": function(d) { return "yes, enable for new users"; },
          "enable-proactive": function(d) { return "yes, enable proactive"; },
          "enable-proactive-default": function(d) { return "yes, enable proactive for new users"; },
          "enable-webshield": function(d) { return "yes, enable WebShield"; },
          "enable-webshield-default": function(d) { return "yes, enable WebShield for new users"; },
          "grant-full-access": function(d) { return "yes, grant full access"; },
          "move-to-ignore": function(d) { return "yes, add to ignore list"; },
          "new-features-management": function(d) { return "Agree and Switch"; },
          "proactive-remove-from-ignore": function(d) { return "yes, remove from ignore list"; },
          "quarantine-malicious": function(d) { return "yes, add to quarantine"; },
          recheck: function(d) { return "yes, remove and recheck"; },
          "remove-full-access": function(d) { return "yes, remove full access"; },
          "restore-from-backup": function(d) { return "yes, restore from backup"; },
          "restore-from-quarantine": function(d) { return "yes, restore"; },
          "restore-original": function(d) { return "yes, restore"; },
          "scope-to-group": function(d) { return "yes, change scope to Group"; },
          "scope-to-local": function(d) { return "yes, change scope to Local"; },
          save: function(d) { return "Save"; },
          "scan-all": function(d) { return "yes, scan all"; },
          "to-black": function(d) { return "yes, move to black list"; },
          "to-white": function(d) { return "yes, move to white list"; },
          "to-drop-group-scope": function(d) { return "yes, move to black list with group scope"; },
          "to-black-group-scope": function(d) { return "yes, move to black list with group scope"; },
          "to-white-group-scope": function(d) { return "yes, move to white list with group scope"; },
          "delete-ip-from-list": function(d) { return "yes, remove from IP lists"; },
          "add-to-black": function(d) { return "Add to BLACK list"; },
          "add-to-drop": function(d) { return "Add to DROP list"; },
          "add-to-white": function(d) { return "Add to WHITE list"; },
          "add-to-drop-group-scope": function(d) { return "Add to BLACK list With group scope"; },
          "add-to-white-group-scope": function(d) { return "Add to WHITE list With group scope"; },
          "scan-start": function(d) { return "yes, start scan"; },
          "scan-stop": function(d) { return "yes, stop scan"; },
          "release-and-send": function(d) { return "yes, release from quarantine"; },
          "delete-emails": function(d) { return "yes, delete"; },
          "delete-accounts": function(d) { return "yes, purging all messages"; },
          "add-white-list": function(d) { return "Yes, add to whitelist"; },
          "remove-white-list": function(d) { return "yes, Remove from whitelist"; }
        },
        titles: {
          cleanup_2: function(d) { return "Clean up those files from malicious code"; },
          cleanup: function(d) { return "Clean up malicious code"; },
          "cleanup-all": function(d) { return "Clean up all files from malicious code"; },
          "delete": function(d) { return "Delete permanently"; },
          "delete-ip": function(d) { return "Remove IP"; },
          "delete-ip-from-list": function(d) { return "Remove from IP lists"; },
          "delete-from-black": function(d) { return "Remove from BLACK list"; },
          "delete-from-white": function(d) { return "Remove from WHITE list"; },
          "delete-ip-from-port": function(d) { return "Delete permanently"; },
          "delete-port": function(d) { return "Delete permanently"; },
          "disable-av": function(d) { return "Disable Malware Cleanup"; },
          "disable-av-default": function(d) { return "Disable Malware Cleanup for new users"; },
          "disable-proactive": function(d) { return "Disable Proactive Defense"; },
          "disable-proactive-default": function(d) { return "Disable Proactive Defense for new users"; },
          "disable-webshield": function(d) { return "Disable WebShield"; },
          "disable-webshield-default": function(d) { return "Disable WebShield for new users"; },
          "enable-av": function(d) { return "Enable Malware Cleanup"; },
          "enable-av-default": function(d) { return "Enable Malware Cleanup for new users"; },
          "enable-proactive": function(d) { return "Enable Proactive Defense"; },
          "enable-proactive-default": function(d) { return "Enable Proactive Defense for new users"; },
          "enable-webshield": function(d) { return "Enable WebShield"; },
          "enable-webshield-default": function(d) { return "Enable WebShield for new users"; },
          "grant-full-access": function(d) { return "Grant Full Access"; },
          "move-to-ignore": function(d) { return "Add to ignore list"; },
          "new-features-management": function(d) { return "New Features Management"; },
          "proactive-remove-from-ignore": function(d) { return "Remove from ignore list"; },
          "quarantine-malicious": function(d) { return "The following files will be moved to quarantine. This action may damage the site or the server. Are you sure?"; },
          recheck: function(d) { return "Remove from ignore list and recheck"; },
          "remove-full-access": function(d) { return "Remove Full Access"; },
          "restore-from-backup": function(d) { return "Restore from backup"; },
          "restore-from-quarantine": function(d) { return "Restore from quarantine"; },
          "restore-original": function(d) { return "Restore (possibly infected) copy made before a cleanup attempt"; },
          "scan-all": function(d) { return "Scan all users' files"; },
          "scope-to-group": function(d) { return "Change scope to Group"; },
          "scope-to-local": function(d) { return "Change scope to Local"; },
          "to-black": function(d) { return "Move to BLACK list"; },
          "to-white": function(d) { return "Move to WHITE list"; },
          "to-drop-group-scope": function(d) { return "Move to BLACK list With group scope"; },
          "to-black-group-scope": function(d) { return "Move to BLACK list With group scope"; },
          "to-white-group-scope": function(d) { return "Move to WHITE list With group scope"; },
          "add-to-black": function(d) { return "Add to BLACK list"; },
          "add-to-drop": function(d) { return "Add to DROP list"; },
          "add-to-white": function(d) { return "Add to WHITE list"; },
          "add-to-drop-group-scope": function(d) { return "Add to BLACK list With group scope"; },
          "add-to-black-group-scope": function(d) { return "Add to BLACK list With group scope"; },
          "add-to-white-group-scope": function(d) { return "Add to WHITE list With group scope"; },
          "scan-start": function(d) { return "Start user scan"; },
          "scan-stop": function(d) { return "Stop user scan"; },
          "release-and-send": function(d) { return "Confirm release from quarantine"; },
          "delete-emails": function(d) { return "Confirm permanent delete"; },
          "delete-accounts": function(d) { return "Confirm purging all messages"; },
          "add-white-list": function(d) { return "Confirm add to whitelist"; },
          "remove-white-list": function(d) { return "Confirm remove from whitelist"; }
        },
        descriptions: {
          "release-and-send": function(d) { return "Do you want to release emails from quarantine?\nEmails will be delivered to recipients:"; },
          "delete-emails": function(d) { return "Do you want to permanently delete emails?"; },
          "delete-accounts": function(d) { return "Do you want to permanently delete accounts?"; },
          "scan-all": function(d) { return "It may take a while depending on the number of files. You can maximize\nperformance by setting up max performance config options."; },
          "add-white-list": function(d) { return "Do you want to add " + d.name + " \nto the whitelist?"; },
          "remove-white-list": function(d) { return "Do you want to remove " + d.name + " \n from the whitelist?"; }
        }
      },
      content: {
        cancel: function(d) { return "Cancel"; },
        confirm: function(d) { return "Confirm"; },
        skip: function(d) { return "Skip"; }
      },
      fileViewer: {
        shownFirst: function(d) { return "Shown first " + d.size + "KB of the file."; },
        title: function(d) { return "View " + d.path; }
      },
      myImunifyUpsell: {
        modalTitle: function(d) { return "How to clean up?"; },
        protectionEnabledLabel: function(d) { return "Protection Enabled"; },
        protectionDisabledLabel: function(d) { return "Protection Disabled"; },
        current: function(d) { return "CURRENT"; },
        buyNow: function(d) { return "BUY NOW"; },
        manualCleanup: {
          title: function(d) { return "Malware must be removed manually"; },
          item_1: function(d) { return "Detection of malware and infections"; },
          item_2: function(d) { return "Detection of Zero-days"; },
          item_3: function(d) { return "Manual malware cleanup required"; },
          item_4: function(d) { return "Zero-days unblocked"; }
        },
        risks: {
          title: function(d) { return "Malware must be removed manually"; },
          item_1: function(d) { return "Traffic stealing"; },
          item_2: function(d) { return "Reputation damage"; },
          item_3: function(d) { return "Data theft"; },
          item_4: function(d) { return "SEO penalties"; },
          item_5: function(d) { return "Service disruption"; },
          item_6: function(d) { return "Legal issues"; },
          item_7: function(d) { return "User trust loss"; },
          item_8: function(d) { return "Financial loss"; },
          item_9: function(d) { return "Security breaches"; }
        },
        autoCleanup: {
          title: function(d) { return "Automatic Malware removal and ongoing protection"; },
          item_1: function(d) { return "Immediately and automatically cleanup the malware recently detected on your site"; },
          item_2: function(d) { return "Real-time malware detection and cleanup"; },
          item_3: function(d) { return "Automatic zero-day threat blocking"; },
          item_4: function(d) { return "No manual intervention needed"; },
          item_5: function(d) { return "Proactive defense against evolving threats"; }
        },
        benefits: {
          title: function(d) { return "Benefits"; },
          item_1: function(d) { return "Saves time and money"; },
          item_2: function(d) { return "Prevents traffic loss"; },
          item_3: function(d) { return "Protects reputation"; },
          item_4: function(d) { return "Safeguards user data"; },
          item_5: function(d) { return "Maintains SEO rankings"; },
          item_6: function(d) { return "Ensures uninterrupted service"; },
          item_7: function(d) { return "Avoids legal issues"; },
          item_8: function(d) { return "Builds user trust"; },
          item_9: function(d) { return "Prevents financial loss"; },
          item_10: function(d) { return "Enhances overall security"; }
        }
      }
    },
    refresher: {
      autoRefresh: function(d) { return "Auto-refresh"; },
      view: function(d) { return "View"; }
    },
    table: {
      columnContent: {
        actions: function(d) { return "Actions"; }
      },
      noResultFound: function(d) { return "NO RESULT FOUND"; },
      noResultInLocal: function(d) { return "No results found in local IP lists, but there are matches in the cloud, see above"; },
      selectAllCheckbox: function(d) { return "Select all"; },
      selectedItems: function(d) { return plural(d.count, 0, en, { "0": "", one: "Selected: 1 item", other: "Selected: " + number(d.count, "count") + " items" }); },
      widgets: {
        content: {
          countrySearch: {
            placeholder: function(d) { return "Enter Country"; },
            title: function(d) { return "Country"; }
          },
          ipSearch: {
            placeholder: function(d) { return "Enter IP"; },
            title: function(d) { return "IP"; }
          },
          list: {
            title: function(d) { return "List"; },
            values: {
              black: function(d) { return "Black"; },
              drop: function(d) { return "Drop"; },
              gray: function(d) { return "Gray"; },
              captcha: function(d) { return "GreyList"; },
              white: function(d) { return "White"; },
              splashscreen: function(d) { return "SplashScreen"; }
            }
          },
          purpose: {
            title: function(d) { return "Purpose"; },
            values: {
              drop: function(d) { return "Drop"; },
              captcha: function(d) { return "GreyList"; },
              white: function(d) { return "White"; },
              splashscreen: function(d) { return "SplashScreen"; }
            }
          },
          type: {
            title: function(d) { return "Type"; },
            values: {
              all: function(d) { return "All items"; },
              ip: function(d) { return "Only Ip"; },
              country: function(d) { return "Only Country"; }
            }
          },
          maliciousStatus: {
            title: function(d) { return "Status"; }
          },
          search: {
            placeholder: function(d) { return "Search"; },
            title: function(d) { return "Search"; }
          },
          switcher: {
            title: function(d) { return "Switcher"; }
          },
          timeframe: {
            title: function(d) { return "Timeframe"; },
            values: {
              "10m": function(d) { return "Last 10 minutes"; },
              "1h": function(d) { return "Last hour"; },
              "24h": function(d) { return "Last 24 hours"; },
              "30d": function(d) { return "Last 30 days"; },
              "30m": function(d) { return "Last 30 minutes"; },
              "4h": function(d) { return "Last 4 hours"; },
              "7d": function(d) { return "Last 7 days"; },
              today: function(d) { return "Today"; },
              yesterday: function(d) { return "Yesterday"; }
            }
          }
        },
        limit: {
          limitPageSize: function(d) { return "Items per page:"; }
        }
      }
    }
  },
  validators: {
    country: function(d) { return "Non-existent country."; },
    domains: function(d) { return "Domains list is not valid."; },
    email: function(d) { return "Email address is not valid."; },
    emails: function(d) { return "Please specify a valid email address"; },
    fileSize: function(d) { return plural(d.count, 0, en, { one: "File", other: "Files" }) + " " + d.files + " can't be uploaded because size is over " + d.maxSize + "MB"; },
    integer: function(d) { return "Should be integer."; },
    ipWithCIDR: function(d) { return "Invalid address net."; },
    listOfIP: function(d) { return "Not a valid list of IP addresses."; },
    listOfServerId: function(d) { return "Invalid server keys in the list: " + d.ids + "."; },
    max: function(d) { return "Should be <= " + d.max + "."; },
    maxFiles: function(d) { return "The maximum number of files is " + d.size; },
    min: function(d) { return "Should be >= " + d.min + "."; },
    maxlength: function(d) { return "Length should be <= " + d.requiredLength + "."; },
    minlength: function(d) { return "Length should be >= " + d.requiredLength + "."; },
    partOfIP: function(d) { return "Not valid part of IP address."; },
    pathToFile: function(d) { return "Path is not valid."; },
    absolutePath: function(d) { return "Path should be absolute"; },
    required: function(d) { return select(d.what, { script: "At least one script", backup_system: "Backup System", country: "Country", default_action: "Default Action", description: "Description", destination: "Destination", email: "Email", integer: "Integer", ip: "IP", key: "Key", password: "Password", path: "path", plugin: "Plugin", port: "Port", protocol: "Protocol", rule_id: "Rule ID", subject: "Subject", username: "Username", emails: "Email", other: "" }) + " required."; },
    serverId: function(d) { return "Please specify a valid server key."; },
    listOfIntegers: function(d) { return "Invalid values in the list: " + d.invalid + "."; },
    matDatepickerParse: function(d) { return "Invalid Date"; },
    matStartDateInvalid: function(d) { return "Invalid Date"; },
    matEndDateInvalid: function(d) { return "Invalid End Date"; }
  },
  widgets: {
    scanId: function(d) { return "Scan ID"; },
    user: function(d) { return "User"; }
  },
  installation: {
    tabs: {
      features: function(d) { return "Features"; },
      log: function(d) { return "Installation log"; }
    },
    status: {
      stopped: function(d) { return "Stopped"; },
      retry: function(d) { return "Retry"; }
    },
    cancelled: {
      messageText: function(d) { return "The installation was cancelled"; },
      hint: {
        retry: function(d) { return "Fix the issues shown and use the 'Retry' button to restart the installation."; },
        support: function(d) { return "If it fails, please contact our |Support|."; }
      }
    },
    log: {
      title: function(d) { return "The installation details are provided bellow:"; },
      titleStopped: function(d) { return "The installation was cancelled. The details are:"; }
    },
    proactive: {
      title: function(d) { return "Proactive Defense"; },
      text: function(d) { return "Imunify360's Proactive Defense protects websites against zero-day attacks - it stops even the malware that no scanner is able to detect. It identifies attacks on your Linux web servers in real time, then blocks potentially malicious executions automatically and with zero latency. \n\n Proactive Defense uses a unique method of identifying security risks - it analyzes what scripts do rather than what is actually in the code."; }
    },
    reputation: {
      title: function(d) { return "Website Reputation Monitoring"; },
      text: function(d) { return "We analyze if your site or IPs are blocked by any blacklists and notify you if they are. Your site reputation is very important. For example, if you are added to the Google blacklist as a site that distributes malware, you will be excluded from Google search results, which can be devastating for business. If you get on an RBL list as a spammer, your emails to customers might not be delivered. If you don't proactively monitor your website’s reputation, you might not find out about blacklisting for weeks or even months, at which point the problem could become ruinous."; }
    },
    malware: {
      title: function(d) { return "Malware Scanner"; },
      text: function(d) { return "Detect any type of malicious file, including backdoors, web-shells, viruses, hacker tools, ‘blackhat SEO’ scripts, phishing pages, and many others. \n\n If malware is detected, automatically remove it with one click. Advanced file deobfuscation techniques enable detection of encrypted malicious code embedded in files, over 97% of which can be cleaned automatically."; }
    },
    firewall: {
      title: function(d) { return "Advanced Firewall"; },
      text: function(d) { return "Imunify360 offers advanced firewall protection that uses herd immunity and artificial intelligence to detect new threats and protect all servers that run the software. The firewall is capable of defending against brute force attacks, DoS attacks, and port scans. \n\n The firewall tightly integrates with mod_security web application firewalls to dramatically enhance its usefulness. In combination with WAF, we can stop the majority of web application attacks even before they start. An advanced SplashScreen system is employed to reduce false positives and make sure that valid customers can reach your website."; }
    },
    patch: {
      title: function(d) { return "Patch Management"; },
      subtitle1: function(d) { return "Rebootless Secure Kernel"; },
      subtitle2: function(d) { return "Hardened PHP"; },
      text1: function(d) { return "Rebootless Secure Kernel powered by KernelCare is a component that keeps your server secure by automatically patching kernels without having to reboot the server. Its agent checks for new patches every four hours and automatically applies them to the running server without any performance impact. KernelCare keeps your kernel updated to help you avoid disastrous incidents."; },
      text2: function(d) { return "Hardened PHP is a component that ensures your web server security by patching all PHP versions against known vulnerabilities, allowing you to run any version of PHP without having to update programs to accommodate newer versions."; }
    },
    start: {
      logoDescription: function(d) { return "Complete, multi-layered web server security platform for Linux servers."; },
      title: function(d) { return "Everything is ready to install the product."; },
      subtitle: function(d) { return "The overall process may take several minutes."; },
      checkbox: function(d) { return "I have read and accepted the|terms and conditions.|"; },
      buttonText: function(d) { return "Install"; },
      note: function(d) { return "Note:"; },
      noteDescription: function(d) { return "Do not uninstall Imunify360 extension or reboot/power-off the server until the installation process is complete."; },
      support: function(d) { return "Imunify customer support"; }
    },
    dashboard: {
      title: function(d) { return "Imunify360 Dashboard"; },
      text: function(d) { return "You can access the Imunify360 dashboard from your control panel. It shows security events as charts and heat maps. \n \n It's a great way to analyze incidents that happened within the past day, week or month."; }
    },
    textForUser: function(d) { return "Imunify installation is not finished yet. Please wait a few minutes and reload the page."; },
    statusMessage: function(d) { return "Installing..."; }
  },
  stoppedService: {
    title: function(d) { return "Imunify agent is not running"; },
    message: function(d) { return "Follow the"; },
    guide: function(d) { return "troubleshooting guide"; },
    or: function(d) { return "or"; },
    support: function(d) { return "contact support"; }
  },
  "reload-page": function(d) { return "Changes you made may not be saved."; },
  emails: {
    title: function(d) { return "Email"; },
    warnings: {
      any: function(d) { return "Something went wrong please try again"; },
      internal: function(d) { return "The batch " + d.type + " failed"; },
      release: function(d) { return "Hourly limit of releases exceeded for account " + d.name; },
      honestResultWarning: function(d) { return d.successItemCount + " out of " + d.total + " messages have been " + d.type + "d \n " + d.failItemCount + " out of " + d.total + " messages failed to be " + d.type + "d, please try again "; }
    },
    headers: {
      "activity-monitor": function(d) { return "Activity monitor"; },
      quarantine: function(d) { return "Quarantine"; },
      statistic: function(d) { return "Statistic"; },
      settings: function(d) { return "Settings"; }
    },
    quarantine: {
      actions: {
        "delete": function(d) { return "Delete"; },
        releaseAndSend: function(d) { return "Release & Send"; },
        view: function(d) { return "View Email"; }
      },
      headers: {
        account: function(d) { return "Account"; },
        "received-date": function(d) { return "Received Date"; },
        sender: function(d) { return "Sender (From)"; },
        recipients: function(d) { return "Recipients"; },
        reasons: function(d) { return "Reasons"; },
        scriptPath: function(d) { return "PHP Script Path"; },
        any: function(d) { return "In any fields"; },
        subject: function(d) { return "Subject"; }
      },
      widgets: {
        "search-by": function(d) { return "Search by"; }
      },
      viewEmail: {
        from: function(d) { return "From"; },
        receivedDate: function(d) { return "Received Date"; },
        recipients: function(d) { return "Recipients"; },
        subject: function(d) { return "Subject"; },
        tabs: {
          body: function(d) { return "Body"; },
          header: function(d) { return "Header"; },
          plain: function(d) { return "Plain Text"; }
        }
      },
      filters: {
        title: function(d) { return "Advanced search"; },
        searchButton: function(d) { return "Search"; },
        receivedDateFrom: function(d) { return "Received Date From"; },
        receivedDateTo: function(d) { return "Received Date to"; },
        "start-date": function(d) { return "Start date"; },
        reason: function(d) { return "Reason"; },
        "end-date": function(d) { return "End date"; }
      }
    },
    settings: {
      tableAction: function(d) { return "Account Settings"; },
      headers: {
        account: function(d) { return "Account"; },
        limit: function(d) { return "Storage capacity MB"; },
        usedSpace: function(d) { return "Used Space MB"; },
        releasesLimit: function(d) { return "Releases Limit"; },
        state: function(d) { return "State"; },
        details: function(d) { return "Details"; }
      },
      actions: {
        purgeAccount: function(d) { return "Purge quarantine"; },
        updateLimit: function(d) { return "Update limit"; },
        releasesLimit: function(d) { return "Update releases limit"; }
      },
      form: {
        formGroup: function(d) { return "Global Settings"; },
        title: {
          totalSpace: function(d) { return "Total Quarantine Space (MB)"; },
          accountLimit: function(d) { return "Update " + d.type + " limit"; },
          limitGroup: function(d) { return "Defaults limits"; },
          quarantineGroup: function(d) { return "Quarantine"; },
          accountSpace: function(d) { return "Per Account Quarantine Space (MB)"; },
          serverLimit: function(d) { return "Server (all accounts)"; },
          accountField: function(d) { return "For an account"; },
          senderLimit: function(d) { return "For a sender (email)"; },
          releasesLimit: function(d) { return "Releases Limit"; },
          limitBytes: function(d) { return "Storage capacity (MB)"; },
          scriptLimit: function(d) { return "For a PHP script"; },
          domainLimit: function(d) { return "For a domain"; },
          limitMode: {
            title: function(d) { return "Sender limit"; },
            recipients: function(d) { return "Apply limit to a number of recipients"; },
            emails: function(d) { return "Apply limit to a number of emails"; }
          }
        }
      }
    },
    activityMonitor: {
      headers: {
        sender: function(d) { return "Sender Object"; },
        sent_out: function(d) { return "HAM / Sent out"; },
        limit: function(d) { return "Limit (hour)"; },
        is_whitelisted: function(d) { return "Whitelisted"; },
        spam: function(d) { return "Quarantined"; },
        actions: function(d) { return "Actions"; },
        domains: function(d) { return "Domain"; },
        emails: function(d) { return "Sender"; },
        scripts: function(d) { return "Script"; },
        any: function(d) { return "In any fields"; }
      },
      advancedSearch: {
        accountName: function(d) { return "Account"; },
        email: function(d) { return "Sender address"; },
        domain: function(d) { return "Domain"; },
        any: function(d) { return "In any fields"; },
        script: function(d) { return "Script"; }
      },
      actions: {
        whiteListSender: function(d) { return "Whitelist sender"; },
        removeWhiteList: function(d) { return "Remove from whitelist"; },
        goToQuarantine: function(d) { return "Go to quarantine"; },
        updateSenderLimit: function(d) { return "Update sender limit"; }
      },
      updateLimitModal: {
        sliderTitle: function(d) { return "Enable limit"; },
        inputTitle: function(d) { return "Limit value"; },
        confirmButton: function(d) { return "Set"; }
      },
      refresh: function(d) { return "Refresh"; },
      notSetLimit: function(d) { return "Limit not set"; }
    }
  }
}